import React, { useEffect, useState, useCallback } from "react";
import altLogo from "../../assets/images/alt-logo.svg";
import altBankLogo from "../../assets/images/alt-finance-logo.svg";
import group1 from "../../assets/images/Group_1.svg";
import rightArrow from "../../assets/images/right_arrow.svg";
import no2 from "../../assets/images/no2.svg";
import no3 from "../../assets/images/no3.png";
import no4 from "../../assets/images/nos4.svg";
import copyButton from "../../assets/images/copy-button.svg";
import { useSelector } from "react-redux";
import "../../index.css";
import { useDispatch } from "react-redux";
import Icon_L from "../../assets/images/Icon_L.svg";
import success from "../../assets/images/success-icon.svg";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import Done from "../../assets/images/Done.svg";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/localStorage";
import axios from "axios";
import { baseBusinessUrl, baseUrl } from "../../utils/baseUrl";
import * as toast from "../../utils/makeToast";
import styles from "./style.module.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  IEmploymentInfo,
  IMeansOfIdentification,
  IReligion,
  IBankBranch,
  IIndustry,
} from "../../models/IEnums.model";
import backArrow from "../../assets/images/backArrow.svg";
import { useNavigate } from "react-router-dom";
import uploadArrow from "../../assets/images/upload-arrow.svg";
import signEdit from "../../assets/images/signEdit.svg";
import signDelete from "../../assets/images/signDelete.svg";
import { Toaster } from "react-hot-toast";
import NewDocumentUpload from "../../Components/BusinessForms/NewDocumentUpload";
import NewAddReference from "../../Components/BusinessForms/NewAddReference";
import AuthCode from "react-auth-code-input";
import ExistingDocumentUpload from "../../Components/BusinessForms/ExistingDocumentUpload";
import {
  links,
  MAX_FILE_UPLOAD_SIZE_FIGURE,
  MAX_FILE_UPLOAD_SIZE_TEXT,
} from "../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as EmailValidator from "email-validator";
import DatePickerComponent from "../../Components/DatePickerComponent";
import CoperateAccountPopUp from "../../Components/coperateAccountPopUp";
import altBankLogoGold from "../../assets/images/alt-finance-logo-gold.svg";
import { decryptResponse } from "../../utils/encryption";
import cbn from "../../assets/icons/cbn.svg";
import Loader from "../../Components/Loader";
import { encryptRequest } from "../../utils/encryption";
import { statesInNigeria } from "../../utils/constants";
import useOtpResendCountdown from "../../customHooks/useOtpResendCountdown";
import SuccessIcon from "../../assets/icons/SuccessIcon";

function BusinessOpenAccount(props: any) {
  const { countdownStop, countdownStr, resetTimer } = useOtpResendCountdown();
  const letx = getLocalStorageItem("jinx");
  const navigate = useNavigate();
  const navigateHome = () => {
    navigate("/");
  };
  const copyAccountNumberToClipboard = (accountNumber: string) => {
    navigator.clipboard.writeText(accountNumber).then(
      function () {
        toast.successToast("Account number copied to clipboard");
      },
      function (err) {
        toast.successToast("Account number was not copied to clipboard");
      },
    );
  };
  const dispatch = useDispatch();
  const [intialPopup, setInitialPopup] = useState(true);
  const [isdocumentUploaded, setIsDocumentUploaded] = useState(false);
  const [tin, setTin] = useState("");
  const [existingAccountNumber, setExistingAccountNumber] = useState("");
  const [signatory, setSignatory] = useState(false);
  const [extraSignatory, setExtraSignatory] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [employmentInfos, setEmploymentInfos] = useState<IEmploymentInfo[]>([]);
  const [idCardtype, setIdCardType] = useState<any>("Permanent Voter's Card");
  const [bvnUpdateValidated, setBvnUpdateValidated] = useState(false);
  const [bvnNextUpdated, setBvnNextUpdated] = useState(false);
  const [bvnNextMandate, setBvnNextMandate] = useState(false);
  const [accountName, setAccountName] = useState("");

  const referenceFormPdf = require("../../assets/pdf/reference_form_nib.pdf");
  const termsAndConditionPdf = require("../../assets/pdf/tac.pdf");
  const [socialMediaType, setSocialMediaType] = useState("");
  const [socialMediaHandle, setSocialMediaHandle] = useState("");
  const handleSocialChange = (event: any) => {
    setSocialMediaType(event.target.value);
  };
  const [showTimer, setShowTimer] = useState(false);

  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails"),
  );

  const [single, setSingle] = useState(true);
  const [multiple, setMultiple] = useState(false);

  //For bvn validation

  const [inputs, setInputs] = useState<any>({});
  const [extraInputs, setExtraInputs] = useState<any>({});

  const [bvnValidating, setBvnValidating] = useState(false);
  const [days, setDays] = useState<string[]>([]);
  const [months, setMonths] = useState<string[]>([]);
  const [years, setYears] = useState<string[]>([]);
  const [bvnClose, setBvnClose] = useState(true);

  const handleChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  const handleExtraChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setExtraInputs((values: any) => ({ ...values, [name]: value }));
  };

  const [businessSignatoryDetailsLoading, setBusinessSignatoryDetailsLoading] =
    useState(false);
  const [signFirstName, setSignFirstName] = useState("");
  const [signMiddleName, setSignMiddleName] = useState("");
  const [signLastName, setSignLastName] = useState("");
  const [signPhoneNumber, setSignPhoneNumber] = useState("");
  const [signExtraFirstName, setSignExtraFirstName] = useState("");
  const [signExtraMiddleName, setSignExtraMiddleName] = useState("");
  const [signExtraLastName, setSignExtralastName] = useState("");
  const [signExtraPhoneNumber, setSignExtraPhoneNumber] = useState("");
  const [signDob, setSignDob] = useState(
    `${inputs.month}-${inputs.day}-${inputs.year}`,
  );
  const [signEmailAddress, setSignEmailAddress] = useState("");
  const [signHouseNumber, setSignHouseNumber] = useState("");
  const [signStreetName, setSignStreetName] = useState("");
  const [signAreaState, setSignAreaState] = useState("");
  const [signBusStop, setSignBusStop] = useState("");
  const [signAddress, setSignAddress] = useState("");
  const [signReligion, setSignReligion] = useState("");
  const [signNationality, setSignNationality] = useState("");
  const [signIdentityCardType, setSignIdentityCardType] = useState("");
  const [signIdCardNumber, setSignIdCardNumber] = useState("");
  const [signIssueDate, setSignIssueDate] = useState(new Date());
  const [signExpiryDate, setSignExpiryDate] = useState(new Date());
  const [signReferralCode, setSignReferralCode] = useState("");
  const [signIdCardName, setSignIdCardName] = useState("");
  const [signCerpacidNumber, setSignCerpacidNumber] = useState("");
  const [deleteSignatoryModal, setDeleteSignatoryModal] = useState(false);
  const [deleteSignatoryModalExtra, setDeleteSignatoryModalExtra] =
    useState(false);
  const [confirmDeleteSignatoryModal, setConfirmDeleteSignatoryModal] =
    useState(false);
  const [
    confirmDeleteSignatoryModalExtra,
    setConfirmDeleteSignatoryModalExtra,
  ] = useState(false);
  const [tinPhoneNumber, setTinPhoneNumber] = useState("");
  const [tinCustomerName, setTinCustomerName] = useState("");
  const [showReferenceFormUpload, setShowReferenceFormUpload] = useState(false);
  const [referenceFormUpload, setReferenceFormUpload] = useState("");
  const [utilityBill, setUtilityBill] = useState("");
  const [showUtilityBill, setShowUtilityBill] = useState(false);

  const nationalityData = [
    {
      id: 1,
      name: "Nigerian",
    },
    {
      id: 2,
      name: "Not Nigerian",
    },
  ];

  const addreference = () => {
    dispatch(setAccountOpeningStep("add-reference"));
  };

  const businessSignatoryDetails = () => {
    let businessSignatoryPayload = {
      tin: tin,
      signatoryBvn: inputs.bvn,
      signatoryDateOfBirth: `${inputs.month}-${inputs.day}-${inputs.year}`,
      firstName: signFirstName,
      secondName: signMiddleName,
      lastName: signLastName,
      phoneNumber: signPhoneNumber,
      emailAddress: signEmailAddress,
      businessHouseNumber: signHouseNumber,
      businessStreetName: signStreetName,
      businessNearestBustop: signBusStop,
      businessState: signAreaState,
      businessNationality: 2,
      cerpacidNumber: signCerpacidNumber,
      // identityCardType: idCardtype,
      identityCardType: "5",
      iDcardNumber: signIdCardNumber,
      issuedDate: signIssueDate,
      expiryDate: signExpiryDate,
      iDcardName: signIdCardName,
    };
    setBusinessSignatoryDetailsLoading(true);
    //  let newTokenPayload = {
    //   refreshToken: letx.refreshToken,
    //   accessToken: letx.accessToken,
    // }
    // axios
    // .post(
    //   `${baseBusinessUrl}Authentication/RefreshToken`,
    //   newTokenPayload
    // )
    // .then((response) => {
    //   setLocalStorageItem("accessToken", response.data.accessToken);
    axios
      .post(
        `${baseBusinessUrl}BusinessSignatoryAccount/BusinessSignatoryDetails`,
        businessSignatoryPayload,
      )
      .then((response) => {
        setSignatoryId(response.data.obj.id);
        if (
          signHouseNumber?.length < 1 ||
          signEmailAddress?.length < 1 ||
          signStreetName?.length < 1 ||
          signBusStop?.length < 1 ||
          signAreaState?.length < 1 ||
          signIdCardNumber?.length < 1 ||
          signIdCardName?.length < 1
        ) {
          toast.errorToast(
            "All required fields should be filed up before moving to the next stage",
          );
        } else if (response.data.isSuccess) {
          toast.successToast(response.data.message);
          setBvnNextMandate(true);
          setBvnNextUpdated(false);
        } else {
          toast.errorToast(response.data.message);
        }

        setBusinessSignatoryDetailsLoading(false);
      })
      .catch((err) => {
        toast.errorToast("Check your internet connection and Try again");

        setBusinessSignatoryDetailsLoading(false);
      });

    // })
    // .catch((err) => {
    //
    //   toast.errorToast("Something went wrong")
    //   setBusinessSignatoryDetailsLoading(false);
    // })
  };

  const businessSignatoryExtraDetails = () => {
    let businessSignatoryPayload = {
      tin: tin,
      signatoryBvn: extraInputs.bvn,
      signatoryDateOfBirth: `${extraInputs.month}-${extraInputs.day}-${extraInputs.year}`,
      firstName: userDetails.extrafirstname,
      secondName: userDetails.extralastName,
      lastName: userDetails.extralastName,
      phoneNumber: userDetails.extraphoneNumber,
      emailAddress: signEmailAddress,
      businessHouseNumber: signHouseNumber,
      businessStreetName: signStreetName,
      businessNearestBustop: signBusStop,
      businessState: signAreaState,
      businessNationality: 2,
      cerpacidNumber: signCerpacidNumber,
      // identityCardType: idCardtype,
      identityCardType: "5",
      iDcardNumber: signIdCardNumber,
      issuedDate: signIssueDate,
      expiryDate: signExpiryDate,
      iDcardName: signIdCardName,
    };
    setBusinessSignatoryDetailsLoading(true);

    axios
      .post(
        `${baseBusinessUrl}BusinessSignatoryAccount/BusinessSignatoryDetails`,
        businessSignatoryPayload,
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.message);
          setBvnNextMandate(true);
          setBvnNextUpdated(false);
        } else {
          toast.errorToast(response.data.message);
        }

        setBusinessSignatoryDetailsLoading(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");

        setBusinessSignatoryDetailsLoading(false);
      });
  };

  const handleValidateBVN = () => {
    if (checkFormValidity()) {
      validateBVN();
    } else {
      toast.errorToast("something went wrong");
    }
  };

  const validateBVN = () => {
    let validateBVNPayload = {
      bvn: inputs.bvn,
      dateOfBirth: `${inputs.month}-${inputs.day}-${inputs.year}`,
    };
    let userDetails = getLocalStorageItem("userDetails") || {};
    setLocalStorageItem(
      "userDetails",
      JSON.stringify({ ...userDetails, bvn: inputs.bvn }),
    );

    setBvnValidating(true);
    axios
      .post(
        `${baseBusinessUrl}Authentication/BvnDateOfBirthValidationWithoutOTP`,
        validateBVNPayload,
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.responseMessage);
          // let userInfo = getLocalStorageItem("userDetails") || {};
          // setLocalStorageItem(
          //   "userDetails",
          //   JSON.stringify({
          //     ...userInfo,
          //     firstName: response.data.firstName,
          //     lastName: response.data.lastName,
          //     middleName: response.data.middleName,
          //     phoneNumber: response.data.phoneNumber,
          //   })
          // );
          setSignFirstName(response.data.firstName);
          setSignLastName(response.data.lastName);
          setSignMiddleName(response.data.middleName);
          setSignPhoneNumber(response.data.phoneNumber);
          setBvnNextUpdated(true);
          setBvnClose(false);

          setBvnUpdateValidated(true);
        } else {
          toast.errorToast(response.data.responseMessage);
        }
        setBvnValidating(false);
      })
      .catch((err) => {
        toast.errorToast("INVALID BVN OR DATE OF BIRTH");

        setBvnValidating(false);
      });
  };

  const validateExtraBVN = () => {
    let validateBVNPayload = {
      bvn: extraInputs.bvn,
      dateOfBirth: `${extraInputs.month}-${extraInputs.day}-${extraInputs.year}`,
    };
    // let userDetails = getLocalStorageItem("userDetails") || {};
    // setLocalStorageItem(
    //   "userDetails",
    //   JSON.stringify({ ...userDetails, bvn: inputs.bvn })
    // );

    setBvnValidating(true);
    axios
      .post(
        `${baseBusinessUrl}Authentication/BvnDateOfBirthValidationWithoutOTP`,
        validateBVNPayload,
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.successToast(response.data.responseMessage);
          setSignExtraFirstName(response.data.firstName);
          setSignExtralastName(response.data.lastName);
          setSignExtraMiddleName(response.data.middleName);
          setSignExtraPhoneNumber(response.data.phoneNumber);
          setBvnNextUpdated(true);
          setBvnClose(false);

          setBvnUpdateValidated(true);

          setBvnUpdateValidated(true);
        } else {
          toast.errorToast(response.data.responseMessage);
        }
        setBvnValidating(false);
      })
      .catch((err) => {
        toast.errorToast("INVALID BVN OR DATE OF BIRTH");

        setBvnValidating(false);
      });
  };

  const checkFormValidity = () => {
    if (
      inputs?.bvn?.length < 11 ||
      inputs?.bvn?.length > 11 ||
      !inputs?.day ||
      !inputs?.month ||
      !inputs?.year
    ) {
      return false;
    } else {
      return true;
    }
  };

  const setDOBValues = () => {
    let calculatedYears = [];

    setDays([
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
    ]);

    setMonths([
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]);

    for (let i = 1900; i < new Date().getFullYear(); i++) {
      calculatedYears.push(`${i}`);
    }

    setYears([...calculatedYears]);
  };

  useEffect(() => {
    dispatch(setAccountOpeningStep("tin-validation"));
    //  dispatch(setAccountOpeningStep("upload-document"));
    getMeansOfIdentification();
    getReligions();
    setDOBValues();
  }, []);

  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [loginTime, setLoginTime] = useState("");

  const storeLoginTime = () => {
    const currentDate = new Date();
    const formattedDateTime = currentDate.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });

    setLoginTime(formattedDateTime);
  };

  useEffect(() => {
    if (shouldFetchData) {
      const hasPassedDateTime = (
        targetDateTimeString,
        referenceDateTimeString,
      ) => {
        const targetDateTime = new Date(targetDateTimeString);
        const referenceDateTime = new Date(referenceDateTimeString);
        return referenceDateTime > targetDateTime;
      };

      const hasPassed = hasPassedDateTime(
        letx.accessTokenExpirationTime,
        loginTime,
      );
      const hasrefreshPassed = hasPassedDateTime(
        letx.refreshTokenExpirationTime,
        loginTime,
      );

      if (hasPassed) {
        let newTokenPayload = {
          refreshToken: letx.refreshToken,
          accessToken: letx.accessToken,
        };
        axios
          .post(
            `${baseBusinessUrl}Authentication/RefreshToken`,
            newTokenPayload,
          )
          .then((response) => {
            setLocalStorageItem("accessToken", response.data.accessToken);
          })
          .catch((err) => {});
      }
      if (hasrefreshPassed) {
        dispatch(setAccountOpeningStep("tin-validation"));
      }
    }
  }, [letx, dispatch, setAccountOpeningStep, shouldFetchData, loginTime]);

  const clickSingle = () => {
    setSingle(true);
    setMultiple(false);
  };

  const clickMultiple = () => {
    setSingle(false);
    setMultiple(true);
  };

  const [result, setResult] = useState("");

  const [validating, setValidating] = useState(false);

  // const { accountType } = useSelector((state) => state.accountOpeningData)
  const { accountOpeningStep } = useSelector(
    (state: any) => state.accountOpeningData,
  );

  const [validated, setValidated] = useState(false);
  const [updateDetailsX, setUpdateDetailsX] = useState(false);
  const [completeSignUpdate, setComplteSignUpdate] = useState(false);

  //signatory code

  const [meansOfIdentification, setMeansOfIdentification] = useState<
    IMeansOfIdentification[]
  >([]);

  const [signUpdateDetails, setSignUpdateDetails] = useState(false);

  const getMeansOfIdentification = () => {
    axios
      .get(`${baseBusinessUrl}Enum/MeansOfIdentification`)
      .then((response) => {
        setMeansOfIdentification(response.data);
      })
      .catch((err) => {});
  };

  const [getReligion, setReligion] = useState([]);

  const getReligions = () => {
    axios
      .get(`${baseBusinessUrl}Enum/Religion`)
      .then((response) => {
        setReligion(response.data);
      })
      .catch((err) => {});
  };

  const handleSetIdCardType = (id: any) => {
    setIdCardType(id);
  };

  //For TIN Validation

  const openSignatory = () => {
    setSignatory(true);
    setBvnClose(true);
    setBvnNextMandate(false);
  };

  const openExtraSigntory = () => {
    setExtraSignatory(true);
    setBvnClose(true);
    setBvnNextMandate(false);
  };

  const [taxOfficeName, setTaxOfficeName] = useState("");
  const [otp, setOtp] = useState("");
  const handleOnChange = (res: string) => {
    setOtp(res);
  };

  const [universalID, setUnversalID] = useState("");

  const getSingleTin = () => {
    if (tin?.length > 13 || tin?.length < 13) {
      setTinError(true);
      setValidateBtnLoading(false);
    } else {
      setValidateBtnLoading(true);
      axios
        .post(`${baseBusinessUrl}BusinessAccount/TinValidation`, { tin })
        .then((getresponse) => {
          // storeLoginTime()
          if (getresponse.data.message == "not found") {
            setTinError(true);
            setValidateBtnLoading(false);
          } else if (
            getresponse.data.message == "Something went wrong, Please try again"
          ) {
            toast.errorToast(
              "Something went wrong while validating TIN, Please try again",
            );

            setValidateBtnLoading(false);
          } else if (!getresponse.data.UserDetails.data.rcNumber) {
            setTinError(true);
            setValidateBtnLoading(false);
          } else {
            setBusinessRegistrationNumber(
              getresponse.data.UserDetails.data.rcNumber,
            );

            setFullAddress(getresponse.data.UserDetails.data.address);

            validateTIN();
          }
          // setUnversalID(getresponse.data.id);
          // setDateOfIncorporation(getresponse.data.dateOfIncorporation);
          // setStreetNumber(getresponse.data.streetNumber);
          // setStreetName(getresponse.data.streetName);
          // setArea(getresponse.data.state);
          // setBusStop(getresponse.data.nearestBustopLandmark);
        })
        .catch((err) => {
          setTinError(true);
          setValidateBtnLoading(false);
        });
    }
  };

  const handleVerifyOTP = useCallback(() => {
    let validateVerifyOtpPayload = {
      phoneNumber: tinPhoneNumber,
      otp: otp,
      bvn: responseBvn,
    };

    setValidating(true);
    setShowTimer(true);

    axios
      .post(
        `${baseBusinessUrl}Authentication/validateOTP`,
        validateVerifyOtpPayload,
      )
      .then((newresponse) => {
        if (newresponse?.data?.accessToken?.length > 0) {
          let userInfo = getLocalStorageItem("userDetails") || {};
          setDateOfIncorporation(
            newresponse?.data?.UserDetails?.registrationDate,
          );
          setLocalStorageItem("accessToken", newresponse.data.accessToken);
          setLocalStorageItem(
            "jinx",
            JSON.stringify({
              refreshToken: newresponse.data.refreshToken,
              accessToken: newresponse.data.accessToken,
              accessTokenExpirationTime:
                newresponse.data.accessTokenExpirationTime,
              refreshTokenExpirationTime:
                newresponse.data.refreshTokenExpirationTime,
            }),
          );
          setLocalStorageItem("userDetails", JSON.stringify({ ...userInfo }));
          storeLoginTime();
          // getSingleTin();
          if (letx?.refreshTokenExpirationTime?.length > 0) {
            setShouldFetchData(true);
          }

          axios
            .get(
              `${baseBusinessUrl}BusinessAccount/BusinessExistingDetails?Tin=${encryptRequest(
                tin,
              )}`,
            )
            .then((response) => {
              // setBusinessName(response.data.businessName);
              // setAccountName(response.data.businessName);
              // setStreetNumber(response.data.streetNumber);
              // setStreetName(response.data.streetName);
              // setBusStop(response.data.nearestBustopLandmark);
              // setArea(response.data.state);
              setValidated(true);
              setValidating(false);
              setUnversalID(response.data.id);
              dispatch(setAccountOpeningStep("open-business-account"));
              // getSingleTin();
            })
            .catch((err) => {
              toast.errorToast("something went wrong");

              setValidating(false);
            });
        } else {
          toast.errorToast(newresponse.data.message);
          setValidating(false);
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");

        setValidating(false);
      });
  }, [dispatch, tin, otp, tinPhoneNumber]);

  const [responseBvn, setResponseBvn] = useState("");

  const validateTIN = () => {
    let validateTinPayload = {
      tin: tin,
      accountNumber: existingAccountNumber,
    };
    if (
      tin?.length > 13 ||
      tin?.length < 13 ||
      existingAccountNumber?.length < 10 ||
      existingAccountNumber?.length > 10
    ) {
      setTinError(true);
      setValidateBtnLoading(false);
    } else {
      setValidateBtnLoading(true);
      axios
        .post(
          `${baseBusinessUrl}/BusinessAccount/TinAccountNumberValidion`,
          validateTinPayload,
          // `${baseBusinessUrl}Authentication/BusinessAccountExistingDetails`,
          // validateTinPayload
        )
        .then((response) => {
          if (
            response.data.responseMessage === "Error validating account number"
          ) {
            toast.errorToast("Error validating account number");
          } else if (!response?.data?.accountDetails?.acC_NAME) {
            setTinError(true);
          } else {
            // setBusinessRegistrationNumber(response.data.UserDetails.data.rcNumber);
            toast.successToast(response?.data?.responseMessage);
            setAccountName(response.data.accountDetails.acC_NAME);
            setBusinessName(response.data.accountDetails.acC_NAME);
            setTinCustomerName(response.data.accountDetails.acC_NAME);
            setTinPhoneNumber(response.data.phoneNumber);
            setResponseBvn(response.data.accountDetails.bvn);
            dispatch(setAccountOpeningStep("otp"));
          }
          setValidateBtnLoading(false);
          //
          // if (response.data.isSuccess) {
          //   setTinPhoneNumber(response.data.phoneNumber);
          //   // setFullAddress(response.data.businessAddress);
          //   toast.successToast(response.data.responseMessage)

          //   setResponseBvn(response.data.accountDetails.bvn)
          //   dispatch(setAccountOpeningStep("otp"));

          // }
          // if (response.status === 200) {
          //
          //  ;
          //   setResponseBvn(response.data.bvn)

          // let sendOTPPayload = {
          //   phoneNumber: response.data.phoneNumber,
          //   customerName: response.data.businessName,
          //   bvn: response.data.bvn,
          // };

          // axios
          //   .post(`${baseBusinessUrl}Authentication/SendOTP`, sendOTPPayload)
          //   .then((newresponse) => {
          //
          //     if (newresponse.data.isSuccess && response.status === 200) {
          //       toast.successToast(newresponse.data.message);
          //       dispatch(setAccountOpeningStep("otp"));

          //       setValidateBtnLoading(false);
          //       setValidated(true);
          //     }
          //     else {
          //       toast.errorToast(newresponse.data.message)
          //     }
          //   })

          //   .catch((err) => {
          //     setTinError(true);
          //
          //     setValidateBtnLoading(false);
          //   });
          // }
        })
        .catch((err) => {
          setTinError(true);

          setValidateBtnLoading(false);
        });
    }
  };

  const [validateBtnLoading, setValidateBtnLoading] = useState(false);

  const reSendOTP = () => {
    let sendOTPPayload = {
      phoneNumber: tinPhoneNumber,
      customerName: tinCustomerName,
      bvn: responseBvn,
    };

    setShowTimer(true);

    axios
      .post(`${baseBusinessUrl}Authentication/SendOTP`, sendOTPPayload)
      .then((newresponse) => {
        if (newresponse.data.isSuccess) {
          toast.successToast(newresponse.data.message);

          toast.successToast("OTP resent to your email or phone number");

          setValidateBtnLoading(false);
          setValidated(true);
        } else {
          toast.successToast("OTP not sent, Please try again Later");
        }
      })
      .catch((err) => {
        setTinError(true);

        setValidateBtnLoading(false);
      });
  };

  // for signing popup upload documents ========================================

  const [uploadSignature, setUploadSignature] = useState("");
  const [showUploadSignature, setShowUploadSignature] = useState(false);
  const [businessSignature, setBusinessSignature] = useState("");
  const [showBusinessSignature, setShowBusinessSignature] = useState(false);
  const [uploadScannedID, setUploadScannedID] = useState("");
  const [showUploadScannedID, setShowUploadScannedID] = useState(false);
  const [mandate, setMandate] = useState("");

  // const uploadImage = (payload: any, type: string) => {
  //   if (type === "signature") {
  //     setShowUploadSignature(true);
  //     setUploadSignature(payload.postedFilebase64);
  //   }

  //   if (type === "BusinessName") {
  //     setShowBusinessSignature(true);
  //     setBusinessSignature(payload.postedFilebase64);
  //   }

  //   if (type === "scannedID") {
  //     setShowUploadScannedID(true);
  //     setUploadScannedID(payload.postedFilebase64);
  //   }
  //   if (type === "certificateOfResgistration") {
  //     setShowCertificateOfRegistration(true);
  //     setCertificateOfRegistration(payload.postedFilebase64);
  //   }

  //   if (type === "applicationForBusinessName") {
  //     setShowApplicationForBusinessName(true);
  //     setApplicationForBusinessName(payload.postedFilebase64);
  //   }

  //   if (type === "referenceFormRealUpload") {
  //     setShowReferenceFormUpload(true);
  //     setReferenceFormUpload(payload.postedFilebase64);
  //   }

  //   if (type === "businessResolution") {
  //     setShowBusinessResolution(true);
  //     setBusinessResolution(payload.postedFilebase64);
  //   }

  //   if (type === "othersDocument") {
  //     setShowOthersDocument(true);
  //     setOthersDocument(payload.postedFilebase64);
  //   }
  // };

  // const handleImageSubmit = (type: string) => {
  //   uploadImage(fileUploadObj, type);
  // };

  // let fileUploadObj: any;

  // const convertToBase64 = (file: any) => {
  //   return new Promise((resolve, reject) => {
  //     const fileReader = new FileReader();
  //     fileReader.readAsDataURL(file);
  //     fileReader.onload = () => {
  //       let fileReaderResult = fileReader.result?.toString();
  //       if (
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "png" ||
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "jpg" ||
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "pdf"
  //       ) {
  //         return resolve(fileReaderResult?.substring(22));
  //       } else if (
  //         fileReader.result
  //           ?.toString()
  //           .substring(0, 25)
  //           .split("/")[1]
  //           .split(";")[0] === "jpeg"
  //       ) {
  //         return resolve(fileReaderResult?.substring(23));
  //       }
  //     };
  //     fileReader.onerror = (error) => {
  //       reject(error);
  //     };
  //   });
  // };

  const [documentLoader, setDocumentLoader] = useState(false);
  const uploadImage = (payload: any, type: string) => {
    if (type === "signature") {
      setShowUploadSignature(false);
      setUploadSignature(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "BusinessName") {
      setShowBusinessSignature(false);
      setBusinessSignature(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "utilityBill") {
      setShowUtilityBill(false);
      setUtilityBill(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "scannedID") {
      setShowUploadScannedID(false);
      setUploadScannedID(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "certificateOfResgistration") {
      setShowCertificateOfRegistration(false);
      setCertificateOfRegistration(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "applicationForBusinessName") {
      setShowApplicationForBusinessName(false);
      setApplicationForBusinessName(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "referenceFormRealUpload") {
      setShowReferenceFormUpload(false);
      setReferenceFormUpload(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "businessResolution") {
      setShowBusinessResolution(false);
      setBusinessResolution(payload.postedFilebase64);
      setDocumentLoader(true);
    } else if (type === "othersDocument") {
      setShowOthersDocument(false);
      setOthersDocument(payload.postedFilebase64);
      setDocumentLoader(true);
    }
    // else if (type === "extraDocument") {
    //   setShowExtraDocument(false);
    //   setExtraDocument(payload.postedFilebase64);
    //   setDocumentLoader(true)
    // }
    axios
      .post(`${baseUrl}Authentication/UploadFile`, payload)
      .then((response) => {
        if (response.data.isSuccess) {
          if (type === "signature") {
            setShowUploadSignature(true);
            setUploadSignature(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "utilityBill") {
            setShowUtilityBill(true);
            setUtilityBill(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "BusinessName") {
            setShowBusinessSignature(true);
            setBusinessSignature(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "scannedID") {
            setShowUploadScannedID(true);
            setUploadScannedID(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "certificateOfResgistration") {
            setShowCertificateOfRegistration(true);
            setCertificateOfRegistration(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "applicationForBusinessName") {
            setShowApplicationForBusinessName(true);
            setApplicationForBusinessName(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "referenceFormRealUpload") {
            setShowReferenceFormUpload(true);
            setReferenceFormUpload(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "businessResolution") {
            setShowBusinessResolution(true);
            setBusinessResolution(response.data?.id);
            setDocumentLoader(false);
          } else if (type === "othersDocument") {
            setShowOthersDocument(true);
            setOthersDocument(response.data?.id);
            setDocumentLoader(false);
          }
          // else if (type === "extraDocument") {
          //   setShowExtraDocument(true);
          //   setExtraDocument(response.data?.id);
          //   setDocumentLoader(false)
          // }
        } else {
          toast.errorToast("Unable to Save File");
          setDocumentLoader(false);
        }
      })
      .catch((err) => {
        setShowUploadSignature(false);
        setShowBusinessSignature(false);
        setShowUploadScannedID(false);
        setShowCertificateOfRegistration(false);
        setShowApplicationForBusinessName(false);
        setShowReferenceFormUpload(false);
        setShowBusinessResolution(false);
        setShowOthersDocument(false);
        // setShowExtraDocument(false)

        toast.errorToast(
          err?.response?.data?.title
            ? err?.response?.data?.title
            : err?.response?.data?.message,
        );
      });
  };

  const handleImageSubmit = (type: string) => {
    uploadImage(fileUploadObj, type);
  };

  let fileUploadObj: any;

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        let fileReaderResult = fileReader.result?.toString();
        return resolve(fileReaderResult);
        // if (
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "png" ||
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "jpg" ||
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "pdf"
        // ) {
        //   return resolve(fileReaderResult?.substring(22));
        // } else if (
        //   fileReader.result
        //     ?.toString()
        //     .substring(0, 25)
        //     .split("/")[1]
        //     .split(";")[0] === "jpeg"
        // ) {
        //   return resolve(fileReaderResult?.substring(23));
        // }
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // const handleFileUpload = async (e: any, type: string) => {
  //   const file = e.target.files[0];
  //   let fileSize = file.size / 1000;
  //   if (fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE) {
  //     toast.errorToast(
  //       `File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`
  //     );
  //     return;
  //   }
  //   let base64: any;

  //   convertToBase64(file).then((res) => {
  //     base64 = res;
  //     fileUploadObj = {
  //       postedFilebase64: res,
  //       documentName: type,
  //       filetype: file.type.split("/")[1],
  //     };
  //     handleImageSubmit(type);
  //   });
  // };

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent input of non-numeric characters
    }
  };

  const handleFileUpload = async (e: any, type: string) => {
    const file = e.target.files[0];
    let fileSize = file.size / 1000;
    const allowedFileTypes = ["image/jpeg", "image/png", "application/pdf"];

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      toast.errorToast("Only image (JPEG, PNG) or PDF files are allowed.");
      return;
    }

    if (fileSize > MAX_FILE_UPLOAD_SIZE_FIGURE) {
      toast.errorToast(
        `File size should be less than ${MAX_FILE_UPLOAD_SIZE_TEXT}`,
      );
      return;
    }
    let base64: any;

    convertToBase64(file).then((res) => {
      base64 = res;
      fileUploadObj = {
        postedFilebase64: res,
        documentName: type,
        filetype: file.type.split("/")[1],
      };
      handleImageSubmit(type);
    });
  };

  //upload-sign document fucntion ========

  const [signatoryadded, setSignatoryAdded] = useState(false);
  const [extraSignatoryAdded, setExtraSignatoryAdded] = useState(false);

  const [signatoryId, setSignatoryId] = useState(null);

  const addedSignatory = () => {
    let validateSignatoryPayload = {
      id: signatoryId,
      mandateInstruction: mandate,
      signature: uploadSignature,
      passport: businessSignature,
      scannedID: uploadScannedID,
    };

    setUpdating(true);

    axios
      .post(
        `${baseBusinessUrl}BusinessSignatoryAccount/BusinessSignatoryDocumentUpload`,
        validateSignatoryPayload,
      )
      .then((response) => {
        setUpdating(false);
        if (response.data.isSuccess) {
          setSignatoryAdded(true);
          setSignatory(false);
          setUpdating(false);
          setSignEmailAddress("");
          setSignHouseNumber("");
          setSignStreetName("");
          setSignAreaState("");
          setSignBusStop("");
          setSignAddress("");
          setSignReligion("");
          setSignNationality("");
          setSignIdentityCardType("");
          setSignIdCardName("");
          setSignIssueDate(new Date());
          setSignExpiryDate(new Date());
          setSignReferralCode("");
          setSignIdCardName("");
          setSignCerpacidNumber("");
          setIdCardType("Permanent Voter's Card");
          setMandate("");
          setUploadSignature("");
          setShowUploadSignature(false);
          setBusinessSignature("");
          setShowBusinessSignature(false);
          setUploadScannedID("");
          setShowUploadScannedID(false);
          setSignIdCardNumber("");
        } else {
          setUpdating(false);
          toast.errorToast("Something went wrong!");
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");

        setUpdating(false);
      });
  };

  const addedExtraSignatory = () => {
    let validateSignatoryPayload = {
      id: signatoryId,
      mandateInstruction: mandate,
      signature: uploadSignature,
      passport: businessSignature,
      scannedID: uploadScannedID,
    };

    setUpdating(true);
    // let newTokenPayload = {
    //   refreshToken: letx.refreshToken,
    //   accessToken: letx.accessToken,
    // }
    // axios
    // .post(
    //   `${baseBusinessUrl}Authentication/RefreshToken`,
    //   newTokenPayload
    // )
    // .then((response) => {
    //   setLocalStorageItem("accessToken", response.data.accessToken);

    axios
      .post(
        `${baseBusinessUrl}BusinessSignatoryAccount/BusinessSignatoryDocumentUpload`,
        validateSignatoryPayload,
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setExtraSignatoryAdded(true);
          setSignatory(false);
          setUpdating(false);
          setExtraSignatory(false);
          setSignEmailAddress("");
          setSignHouseNumber("");
          setSignStreetName("");
          setSignAreaState("");
          setSignBusStop("");
          setSignAddress("");
          setSignReligion("");
          setSignNationality("");
          setSignIdentityCardType("");
          setSignIdCardName("");
          setSignIssueDate(new Date());
          setSignExpiryDate(new Date());
          setSignReferralCode("");
          setSignIdCardName("");
          setSignCerpacidNumber("");
          setIdCardType("Permanent Voter's Card");
          setSignIdCardNumber("");
          setMandate("");
          setUploadSignature("");
          setShowUploadSignature(false);
          setBusinessSignature("");
          setShowBusinessSignature(false);
          setUploadScannedID("");
          setShowUploadScannedID(false);
        } else {
          setUpdating(false);
          toast.errorToast("Something went wrong!");
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");

        setUpdating(false);
      });

    // })
    // .catch((err) => {
    //
    //   toast.errorToast("Something went wrong")
    //   setUpdating(false);
    // })
  };

  const completeBusinessDetails = () => {
    let completeBusinessDetailsPayload = {
      tin: tin,
      businessName: businessName,
      businessRegistrationNumber: businessRegistrationNumber,
      streetNumber: streetnumber,
      streetName: streetname,
      nearestBustopLandmark: busStop,
      state: area,
      businessPhoneNumber: businessPhoneNumber,
      dateOfIncorporation: dateOfIncorporation,
      referralCode: referralCode,
    };

    setUpdating(true);
    //  let newTokenPayload = {
    //   refreshToken: letx.refreshToken,
    //   accessToken: letx.accessToken,
    // }
    // axios
    // .post(
    //   `${baseBusinessUrl}Authentication/RefreshToken`,
    //   newTokenPayload
    // )
    // .then((response) => {
    //   setLocalStorageItem("accessToken", response.data.accessToken);
    axios
      .post(
        `${baseBusinessUrl}BusinessAccount/BusinessDetails`,
        completeBusinessDetailsPayload,
      )
      .then((response) => {
        if (response.data) {
          setComplteSignUpdate(true);
          setUpdateDetailsX(true);
          setUnversalID(response.data.obj.id);
          toast.successToast("Details Updated Successfully");
          dispatch(setAccountOpeningStep("upload-document"));
          setUpdating(false);
        }
      })
      .catch((err) => {
        toast.errorToast("something went wrong");

        setUpdating(false);
      });

    // })
    // .catch((err) => {
    //
    //   toast.errorToast("Something went wrong")
    //   setUpdating(false);
    // })
  };

  const signEditFunction = () => {
    setSignatory(true);
  };

  const deleteEditFunction = () => {
    setDeleteSignatoryModal(true);
  };

  const deleteEditExtraFunction = () => {
    setDeleteSignatoryModalExtra(true);
  };

  const maindeleteFunction = () => {
    setSignatoryAdded(false);
    setConfirmDeleteSignatoryModal(true);

    setDeleteSignatoryModal(false);
  };

  const maindeleteFunctionExtra = () => {
    setExtraSignatoryAdded(false);
    setConfirmDeleteSignatoryModalExtra(true);
    setDeleteSignatoryModalExtra(false);
  };

  const [tinError, setTinError] = useState(false);
  const closeTinError = () => {
    setTinError(false);
  };

  // my form data

  const [businessName, setBusinessName] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("");
  const [streetname, setStreetName] = useState("");
  const [streetnumber, setStreetNumber] = useState("");
  const [busStop, setBusStop] = useState("");
  const [area, setArea] = useState("");
  const [businessPhoneNumber, setBusinessPhoneNumber] = useState("");
  const [dateOfIncorporation, setDateOfIncorporation] = useState("");
  const [fullAddress, setFullAddress] = useState("");
  const [referralCode, setReferralCode] = useState("");

  const previousMandateFuntion = () => {
    setBvnNextMandate(false);
    setBvnNextUpdated(true);
  };

  const previousSigantoryBusinessDetails = () => {
    setBvnClose(true);
    setBvnNextUpdated(false);
  };

  // This is for the document upload module

  const [bankBranches, setBankBranches] = useState<IBankBranch[]>([]);
  const [selectIndustry, setSelectIndustry] = useState("");

  const [smsAlert, setSmsAlert] = useState(true);
  const [chequeBook, setChequeBook] = useState(false);
  const [ngn, setNgn] = useState(false);
  const [usd, setUsd] = useState(false);
  const [euro, setEuro] = useState(false);
  const [gdp, setGdp] = useState(false);
  const [termsAndCondition, setTermsAndCondition] = useState(false);
  const [branchOfDomiciliation, setBranchOfDomiciliation] = useState("");
  const [certificateOfRegistration, setCertificateOfRegistration] =
    useState("");
  const [showCertificateOfRegistration, setShowCertificateOfRegistration] =
    useState(false);
  const [applicationForBusinessName, setApplicationForBusinessName] =
    useState("");
  const [showApplicationForBusinessName, setShowApplicationForBusinessName] =
    useState(false);
  const [businessResolution, setBusinessResolution] = useState("");
  const [showBusinessResolution, setShowBusinessResolution] = useState(false);
  const [othersDocument, setOthersDocument] = useState("");
  const [showOthersDocument, setShowOthersDocument] = useState(false);
  const handleChangeSelect = (event: any) => {
    setSelectIndustry(event.target.value);
  };
  const handleChangeBranch = (event: any) => {
    setBranchOfDomiciliation(event.target.value);
  };

  const [isYesSelected, setIsYesSelected] = useState(false);
  const [isNoSelected, setISNoSelected] = useState(true);
  const [showDocument, setShowDocument] = useState(false);

  const handleIsYesSelected = () => {
    setIsYesSelected(true);
    setISNoSelected(false);
    setShowDocument(true);
  };

  const handleIsNoSelected = () => {
    setIsYesSelected(false);
    setISNoSelected(true);
    setShowDocument(false);
  };

  //
  const [signEmailAddressBlurred, setSignEmailAddressBlurred] =
    useState<boolean>(false);
  const handleOnBlurSignEmailAddress = () => {
    setSignEmailAddressBlurred(true);
  };

  const [emailAddressBlurred, setEmailAddressBlurred] =
    useState<boolean>(false);
  const handleOnBlurEmailAddress = () => {
    setEmailAddressBlurred(true);
  };

  const movePrevious = () => {
    dispatch(setAccountOpeningStep("open-business-account"));
  };

  const getBankBranches = () => {
    axios
      .get(`${baseBusinessUrl}Enum/BranchCodeList`)
      .then((response) => {
        setBankBranches(response.data);
      })
      .catch((err) => {});
  };

  const industries = [
    {
      id: 1,
      name: "Education",
    },
    {
      id: 2,
      name: "Legal and accounting service",
    },
    {
      id: 3,
      name: "Pharmaceuticals",
    },
    {
      id: 4,
      name: "Hospital and clinic",
    },
    {
      id: 5,
      name: "Others",
    },
  ];

  useEffect(() => {
    getBankBranches();
  }, []);

  const [fullAccountNumber, setFullAccountNumber] = useState([]);

  const submitNewDocumentUpload = () => {
    // let businessRefereePayload = {
    //   id: universalID,
    //   certificateOfRegistration: certificateOfRegistration,
    //   applicationForBusinessName: applicationForBusinessName,
    //   businessResolution: businessResolution,
    //   others: othersDocument,
    //   typeOfIndustry: 1,
    //   branchOfDomiciliation: 2,
    //   // currencyOfAccountUSD: "840",
    //   // currencyOfAccountGBP: "826",
    //   // currencyOfAccountNAIRA: "566",
    //   // currencyOfAccountEURO: "978",
    //   currencyOfAccountUSD: "",
    //   currencyOfAccountGBP: "",
    //   currencyOfAccountNAIRA: "",
    //   currencyOfAccountEURO: "",
    //   smsAlertValueAddedService: true,
    //   emailAlertValueAddedService: true,
    //   checkBookValueAddedService: true,
    //   termsCondition: true,
    //   isFlagged: false,
    //   accountTypecode: "210201",
    //   accountTypeName: "Corporate Account",
    //   occupationName: accountName,
    //   ref1Url: referenceFormUpload,
    //   ref2Url: ""
    // };

    let businessRefereePayload = {
      id: universalID,
      certificateOfRegistration: certificateOfRegistration,
      applicationForBusinessName: applicationForBusinessName,
      businessResolution: businessResolution,
      utilityBill: utilityBill,
      others: othersDocument,
      typeOfIndustry: parseInt(selectIndustry),
      branchOfDomiciliation: parseInt(branchOfDomiciliation),
      // currencyOfAccountUSD: "840",
      // currencyOfAccountGBP: "826",
      // currencyOfAccountNAIRA: "566",
      // currencyOfAccountEURO: "978",
      currencyOfAccountUSD: "",
      currencyOfAccountGBP: "",
      currencyOfAccountNAIRA: "",
      currencyOfAccountEURO: "",
      smsAlertValueAddedService: true,
      emailAlertValueAddedService: true,
      checkBookValueAddedService: true,
      termsCondition: true,
      isFlagged: false,
      accountTypecode: "",
      accountTypeName: "Corporate Account",
      occupationName: accountName,
      ref1Url: "",
      ref2Url: "",
    };

    if (usd) {
      businessRefereePayload.currencyOfAccountUSD = "840";
    }
    if (gdp) {
      businessRefereePayload.currencyOfAccountGBP = "826";
    }
    if (euro) {
      businessRefereePayload.currencyOfAccountEURO = "978";
    }
    if (ngn) {
      businessRefereePayload.currencyOfAccountNAIRA = "566";
    }

    setUpdating(true);
    axios
      .post(
        `${baseBusinessUrl}BusinessAccount/BusinessDocumentUpload`,
        businessRefereePayload,
      )
      .then((response) => {
        if (
          response?.data?.length > 0 &&
          response?.data[0]?.responseCode == "20"
        ) {
          toast.errorToast(response?.data[0]?.responseMessage);
          setUpdating(false);
          return;
        }
        if (response?.data?.length > 0 && !response?.data[0]?.accountNo) {
          toast.errorToast(response?.data[0]?.responseMessage);
          setUpdating(false);
          return;
        }
        if (response.data) {
          setFullAccountNumber(response.data);
          dispatch(setAccountOpeningStep("success-business-account"));
          setIsDocumentUploaded(true);
        }
        setUpdating(false);
      })
      .catch((err) => {
        toast.errorToast("something went wrong");

        setUpdating(false);
      });
  };

  return (
    <div>
      {documentLoader && <Loader />}
      {/* <Toaster position="top-center" reverseOrder={false} /> */}
      {tinError && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Invalid RCN/BRN</h1>
            <p>RCN/BRN was not found, kindly check and retry</p>
            <div className={styles.ErrorButtonFlex}>
              <button className={styles.ErrorCancel} onClick={closeTinError}>
                Cancel
              </button>
              <button className={styles.ErrorRetry} onClick={closeTinError}>
                Retry
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteSignatoryModal && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Delete signatory</h1>
            <p>Are you sure you want to delete this signatory?</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setDeleteSignatoryModal(false)}
              >
                Cancel
              </button>
              <button
                className={styles.ErrorRetry}
                onClick={maindeleteFunction}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {deleteSignatoryModalExtra && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Delete signatory</h1>
            <p>Are you sure you want to delete this signatory?</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setDeleteSignatoryModalExtra(false)}
              >
                Cancel
              </button>
              <button
                className={styles.ErrorRetry}
                onClick={maindeleteFunctionExtra}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmDeleteSignatoryModal && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Signatory deleted</h1>
            <p>The selected signatory has been deleted!</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setConfirmDeleteSignatoryModal(false)}
              >
                okay
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmDeleteSignatoryModalExtra && (
        <div className={styles.ErrorBg}>
          <div className={styles.ErrorContain}>
            <h1>Signatory deleted</h1>
            <p>The selected signatory has been deleted!</p>
            <div className={styles.ErrorButtonFlex}>
              <button
                className={styles.ErrorCancel}
                onClick={() => setConfirmDeleteSignatoryModalExtra(false)}
              >
                okay
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="container-fluid row ">
        <div className={`col-md-5 d-none d-md-inline  ${styles.bg}`}>
          <div className="logo pl-4 pt-5">
            {/* <img src={altLogo} alt="alternative finance logo" onClick="document.location='index.html'" /> */}
            <img src={altBankLogo} alt="alternative finance logo" />
          </div>
          <div className={styles.footer}>
            <p>
              Licensed by Central Bank of Nigeria{" "}
              <img src={cbn} alt="cbn-icon" /> | Powered by{" "}
              <span>The Alternative Bank</span>
            </p>
          </div>
        </div>

        <div className="col-md-7 right_col">
          <div className="d-flex justify-content-end">
            <div className="d-flex flex-column pt-5">
              <div className="d-flex justify-content-end">
                <h1 className="pr-3 mb-4 text-capitalize">Business account</h1>
              </div>
              <nav className="mb-4">
                <ol className="breadcrumb bg-white float-right">
                  <li className="breadcrumb-item">
                    {" "}
                    <a href="#">
                      {validated ? (
                        <span>
                          <img className="pr-1" src={Done} alt="" />
                        </span>
                      ) : (
                        <span>
                          <img className="pr-1" src={group1} alt="" />
                        </span>
                      )}
                      TIN Validation &nbsp;
                      <span>
                        <img src={rightArrow} alt="" />
                      </span>
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    {" "}
                    <a href="#">
                      {completeSignUpdate ? (
                        <span>
                          <img className="pr-1" src={Done} alt="" />
                        </span>
                      ) : (
                        <span>
                          <img className="pr-1" src={no2} alt="" />
                        </span>
                      )}{" "}
                      Update details &nbsp;
                      <span>
                        <img src={rightArrow} alt="" />
                      </span>
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    {" "}
                    <a href="#">
                      {isdocumentUploaded ? (
                        <span>
                          <img className="pr-1" src={Done} alt="" />
                        </span>
                      ) : (
                        <span>
                          <img className="pr-1" src={no3} alt="" />
                        </span>
                      )}
                      Document Upload
                      {accountOpeningStep === "add-reference" && (
                        <span>
                          <img src={rightArrow} alt="" />
                        </span>
                      )}
                    </a>
                  </li>
                  {accountOpeningStep === "add-reference" && (
                    <li className="breadcrumb-item">
                      {" "}
                      <a href="#">
                        <span>
                          <img className="pr-1" src={no4} alt="" />
                        </span>
                        Add reference
                      </a>
                    </li>
                  )}
                </ol>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-md-11 card validation-card pb-4">
              {accountOpeningStep === "tin-validation" ? (
                <div>
                  <div className="card-form px-4">
                    <div className="card-body">
                      <h4 className="card-title text-center pl-5 mt-4">
                        Validation
                      </h4>
                      <div className="bvn_val mb-4">
                        <img src={Icon_L} alt="" />
                        <small className="sterling-grey-text ml-4">
                          Kindly ensure that your TIN information is up to date
                        </small>
                      </div>
                      <div className="form-group">
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Existing account number
                          </label>
                        </div>
                        <input
                          className="form-control bvn_input text-muted border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="Enter your existing alternative bank account number"
                          value={existingAccountNumber}
                          onChange={(e) => {
                            setExistingAccountNumber(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group" style={{ marginTop: "15px" }}>
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Enter TIN
                          </label>
                          <i
                            className="bx bxs-info-circle"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
                          ></i>
                        </div>
                        <input
                          className="form-control bvn_input text-muted border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="RC1234567"
                          value={tin}
                          onChange={(e) => {
                            setTin(e.target.value);
                          }}
                        />
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        {validateBtnLoading ? (
                          <div
                            className="spinner-border text-gold"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <button
                            className="btn btn-dange float-right btn-filled-red"
                            onClick={getSingleTin}
                          >
                            Validate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {accountOpeningStep === "open-business-account" ? (
                <div>
                  {intialPopup && (
                    <CoperateAccountPopUp setInitialPopup={setInitialPopup} />
                  )}

                  <div className="card-body">
                    <h4 className="card-title text-center pl-3 mt-4">
                      Update details
                    </h4>
                    <p className="text-center pl-5 no-wrap">
                      Hello{" "}
                      <span className="font-weight-bold">
                        <b>{businessName}</b>{" "}
                      </span>
                      welcome to Alternative Bank
                    </p>
                    <div className="bvn_val mb-4" id="fader">
                      <img src={Icon_L} alt="" />
                      <small className="sterling-grey-text ml-4 font-weight-bold">
                        <b>Update your address</b>
                      </small>
                    </div>
                    {/* <div className="row">
                      <div className="col sec">
                        <div className="row form-row mb-3">
                          <div className="col-lg-6 mr-2">
                            <label className="label_text">Business name</label>
                            <input
                              onChange={(e) => setBusinessName(e.target.value)}
                              value={businessName}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter business name"
                            />
                          </div>
                          <div className="col-lg-6">
                            <label className="label_text">
                              Business registration number
                            </label>
                            <input
                              onChange={(e) =>
                                setBusinessRegistrationNumber(e.target.value)
                              }
                              value={businessRegistrationNumber}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter business registration number"
                            />
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="form-group mb-4">
                      <label className="label_text">
                        Account name{" "}
                        <sup style={{ color: "red" }}>
                          <b>**</b>
                        </sup>
                      </label>
                      <input
                        value={accountName}
                        onChange={(e) => setAccountName(e.target.value)}
                        type="text"
                        className="form-control bg-white border-dark"
                        placeholder="Enter Account name"
                      />
                    </div>

                    <div className="row"></div>
                    <label
                      htmlFor="residentialaddress"
                      className="label_text my-2 mt-4 font-weight-bold"
                    >
                      <b>Residential address </b>
                    </label>

                    <div className="row">
                      <div className="col sec">
                        <div className="row form-row mb-3">
                          <div className="col-lg-6 mr-2">
                            <label className="label_text">
                              House number{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              value={streetnumber}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter House number"
                              onChange={(e) => setStreetNumber(e.target.value)}
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                          <div className="col-lg-6">
                            <label className="label_text">
                              Street name{" "}
                              <sup style={{ color: "red" }}>
                                <b>**</b>
                              </sup>
                            </label>
                            <input
                              value={streetname}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter street name"
                              onChange={(e) => setStreetName(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mb-4">
                      <label htmlFor="streetname" className="label_text">
                        Nearest bus-top/landmark{" "}
                        <sup style={{ color: "red" }}>
                          <b>**</b>
                        </sup>
                      </label>
                      <input
                        value={busStop}
                        type="text"
                        className="form-control bg-white border-dark"
                        placeholder="Enter nearest bus stop"
                        onChange={(e) => setBusStop(e.target.value)}
                      />
                    </div>

                    <div className="form-group mb-4">
                      <label htmlFor="housenumber" className="label_text">
                        Area/State{" "}
                        <sup style={{ color: "red" }}>
                          <b>**</b>
                        </sup>
                      </label>
                      {/* <input
                        name="areaState"
                        value={area}
                        type="text"
                        className="form-control bg-white border-dark"
                        placeholder="Enter Area/State"
                        onChange={(e) => setArea(e.target.value)}
                      /> */}

                      <select
                        name="areaState"
                        onChange={(e) => setArea(e.target.value)}
                        value={area}
                        className="form-control border-dark"
                        style={{
                          padding: "13px",
                        }}
                      >
                        <option value="">Select state</option>
                        {statesInNigeria.map((state: any) => {
                          return (
                            <option key={state.name} value={state.name}>
                              {state.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="form-group mb-4">
                      <input
                        name="address"
                        value={fullAddress}
                        className="form-control sec border-dark"
                        type="text"
                        placeholder="Enter full address"
                      />
                      <br />
                    </div>
                    <label htmlFor="">Do you want to add signatories?</label>
                    <hr />
                    <div className="form-group">
                      <label htmlFor="idcardtype" className="label_text">
                        Select count of signatory
                      </label>

                      <div className="identity-tab">
                        <div className={styles.flex}>
                          <p
                            onClick={clickSingle}
                            className={`${single ? `${styles.active}` : ""}`}
                          >
                            Single signatory
                          </p>
                          <p
                            onClick={clickMultiple}
                            className={`${multiple ? `${styles.active}` : ""}`}
                          >
                            Multiple signatory
                          </p>
                        </div>
                      </div>
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane show fade active"
                          id="pills-int"
                          role="tabpanel"
                          aria-labelledby="pills-int-tab"
                        >
                          {signatoryadded && (
                            <div className={styles.styleAddedPlaces}>
                              <div className={styles.firstSignatoryPlace}>
                                <p style={{ fontSize: "0.9rem" }}>
                                  Primary Signatory
                                </p>
                                <p>
                                  {`${signFirstName} ${" "} ${signMiddleName} ${" "} ${signLastName}`}
                                </p>
                              </div>
                              <div className={styles.iconSignatory}>
                                <img
                                  src={signEdit}
                                  alt=""
                                  onClick={signEditFunction}
                                />
                                <img
                                  src={signDelete}
                                  alt=""
                                  onClick={deleteEditFunction}
                                />
                              </div>
                            </div>
                          )}
                          {extraSignatoryAdded && (
                            <div className={styles.styleAddedPlaces}>
                              <div
                                className={styles.firstSignatoryPlace}
                                style={{ marginTop: "10px" }}
                              >
                                <p>
                                  {`${signExtraFirstName} ${" "} ${signExtraMiddleName} ${" "} ${signExtraLastName}`}
                                </p>
                              </div>
                              <div className={styles.iconSignatory}>
                                <img
                                  src={signEdit}
                                  alt=""
                                  onClick={signEditFunction}
                                />
                                <img
                                  src={signDelete}
                                  alt=""
                                  onClick={deleteEditExtraFunction}
                                />
                              </div>
                            </div>
                          )}
                          {!signatoryadded && (
                            <p
                              className={styles.sign}
                              onClick={openSignatory}
                              style={{ cursor: "pointer" }}
                            >
                              click to add signatory
                            </p>
                          )}
                          {multiple && signatoryadded ? (
                            <>
                              <hr className={styles.hr} />
                              <br />
                              <p
                                className={styles.sign}
                                onClick={openExtraSigntory}
                                style={{ cursor: "pointer" }}
                              >
                                click to add signatory
                              </p>
                              <br />
                              <hr />
                            </>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ marginTop: "40px" }}>
                      <div className="col sec">
                        <div className="row form-row mb-3">
                          <div className="col-lg-6 mr-2">
                            <label className="label_text">
                              Social media type
                            </label>
                            <select
                              name="social"
                              value={socialMediaType}
                              onChange={handleSocialChange}
                              className="form-control bvn_inpu border-dark"
                              style={{ marginRight: "10px" }}
                            >
                              <option key={""} value={""}>
                                Choose
                              </option>
                              <option key={"instagram"} value={"instagram"}>
                                Instagram
                              </option>
                              <option key={"facebook"} value={"facebook"}>
                                facebook
                              </option>
                              <option key={"twitter"} value={"twitter"}>
                                twitter
                              </option>
                            </select>
                          </div>
                          <div className="col-lg-6">
                            <label className="label_text">
                              Enter social link/ handle
                            </label>
                            <input
                              value={socialMediaHandle}
                              onChange={(e) => {
                                setSocialMediaHandle(e.target.value);
                              }}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="@easynote23"
                            />
                            {/* <DatePicker
                                selected={dateOfIncorporation}
                                onChange={(date: Date) =>
                                  setDateOfIncorporation(date)
                                }
                                customInput={<ExampleCustomInput />}
                              /> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group mt-4">
                      {!multiple && <hr className={styles.hr} />}

                      <label htmlFor="refferalcode" className="label_text">
                        DAO/Referral code(optional)
                      </label>
                      <input
                        name="referralCode"
                        onChange={(e) => setReferralCode(e.target.value)}
                        value={referralCode}
                        className="form-control border-dark"
                        type="text"
                        id="name"
                        placeholder="Enter referral code"
                      />
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        style={{ marginRight: "10px" }}
                        className="btn btn-outline-gold mr-3 btn-filled-white"
                        onClick={() =>
                          dispatch(setAccountOpeningStep("tin-validation"))
                        }
                      >
                        Previous
                      </button>

                      {!signatoryadded ||
                      busStop?.length < 1 ||
                      accountName?.length < 1 ? (
                        <button className={styles.submit}>Complete</button>
                      ) : (
                        <>
                          {updating ? (
                            <div
                              className="spinner-border text-gold"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-danger btn-filled-red"
                              onClick={completeBusinessDetails}
                            >
                              Complete
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {accountOpeningStep === "otp" && (
                <div>
                  <div className=" card-form pl-5 pr-5 ">
                    <div className="card-body text-center">
                      <h4 className="card-title text-center pt-4 mt-5">
                        Enter OTP
                      </h4>
                      <p className="text-muted">
                        An OTP has been sent to the mobile number and email
                        captured in <br />
                        your BVN. Kindly enter the OTP to proceed.
                      </p>

                      <div style={{ margin: "15px 0" }}>
                        <AuthCode
                          inputClassName={styles.AuthCode}
                          placeholder="*"
                          length={4}
                          allowedCharacters="numeric"
                          onChange={handleOnChange}
                        />
                      </div>

                      {validating ? (
                        <div
                          className="spinner-border text-gold mb-4"
                          role="status"
                        >
                          <span className="sr-only"></span>
                        </div>
                      ) : (
                        <button
                          disabled={otp.length != 4}
                          type="submit"
                          className="btn btn-danger btn-filled-red mb-4 proceed-btn"
                          onClick={handleVerifyOTP}
                        >
                          Proceed
                        </button>
                      )}

                      <p>
                        {countdownStop ? (
                          <small>
                            Did not get the OTP?{" "}
                            <span className="font-weight-bold">
                              <u className="cursor-pointer" onClick={reSendOTP}>
                                Resend OTP
                              </u>
                              {/* {!showTimer ? (
                              <u className="cursor-pointer" onClick={reSendOTP}>
                                Resend OTP
                              </u>
                            ) : (
                              <CountdownTimer
                                initialMinutes={3}
                                onComplete={() => setShowTimer(false)}
                              />
                            )} */}
                            </span>
                          </small>
                        ) : (
                          <small>Resend code in {countdownStr}</small>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {accountOpeningStep === "upload-document" && (
                <div>
                  <div className=" card-form pl-1 pr-1 ">
                    <div className="card-body">
                      <h4 className="card-title text-center pl-3 mt-5">
                        Document upload
                      </h4>
                      <br />
                      <p className="text-center">
                        <small>The file format should be JPEG or PDF</small>
                      </p>
                      <div className={styles.selector}>
                        <div className={styles.firstSelector}>
                          <img src={Icon_L} alt="" />
                          <p>Do you have any pending documents to upload?</p>
                        </div>
                        <div className={styles.secondSelector}>
                          <p
                            className={
                              isYesSelected ? `${styles.selected}` : ``
                            }
                            onClick={handleIsYesSelected}
                          >
                            Yes
                          </p>
                          <p
                            className={isNoSelected ? `${styles.selected}` : ``}
                            onClick={handleIsNoSelected}
                          >
                            No
                          </p>
                        </div>
                      </div>
                      {showDocument && (
                        <>
                          <div className="row">
                            <div className="col-md-6 mt-2">
                              <div className="col-md-6">
                                <label
                                  htmlFor="firstname"
                                  className="label_text2 text-nowrap font-weight-bold"
                                >
                                  <b>
                                    {" "}
                                    Certificate of registration
                                    <sup style={{ color: "red" }}>
                                      <b>**</b>
                                    </sup>
                                  </b>
                                </label>
                                <label
                                  className="cursor-pointer"
                                  htmlFor="parentofCertificateOfResgistration"
                                >
                                  <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                    {showCertificateOfRegistration ? (
                                      <p className="label_text">
                                        Certificate Uploaded
                                      </p>
                                    ) : (
                                      <p className="label_text">
                                        Click or drag <br /> and drop file
                                      </p>
                                    )}

                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </div>
                                  <input
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        "certificateOfResgistration",
                                      )
                                    }
                                    id="parentofCertificateOfResgistration"
                                    className="input-file-type"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpg, image/jpeg"
                                  />
                                </label>
                              </div>
                            </div>

                            <div className="col-xl-6">
                              <div className="col-lg-12 ml-n3">
                                <label
                                  htmlFor="firstname"
                                  className="label_text2 text-nowrap font-weight-bold"
                                >
                                  <b>
                                    {" "}
                                    Application for business name
                                    <sup style={{ color: "red" }}>
                                      <b>**</b>
                                    </sup>
                                  </b>
                                </label>
                                <label
                                  className="cursor-pointer"
                                  htmlFor="BusinessName"
                                >
                                  <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                    {showApplicationForBusinessName ? (
                                      <p className="label_text">
                                        Application Uploaded
                                      </p>
                                    ) : (
                                      <p className="label_text">
                                        Click to upload or drag
                                        <br />
                                        and drop file
                                      </p>
                                    )}

                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </div>
                                  <input
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        "applicationForBusinessName",
                                      )
                                    }
                                    id="BusinessName"
                                    className="input-file-type"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpg, image/jpeg"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mt-2">
                              <div className="col-md-6">
                                <label
                                  htmlFor="firstname"
                                  className="label_text2 text-nowrap font-weight-bold"
                                >
                                  <b>
                                    Business resolution
                                    <sup style={{ color: "red" }}>
                                      <b>**</b>
                                    </sup>
                                  </b>
                                </label>
                                <label
                                  className="cursor-pointer"
                                  htmlFor="BusinessResolution"
                                >
                                  <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                    {showBusinessResolution ? (
                                      <p className="label_text">
                                        Document uploaded
                                      </p>
                                    ) : (
                                      <p className="label_text">
                                        Click to upload or drag
                                        <br />
                                        and drop file
                                      </p>
                                    )}

                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </div>
                                  <input
                                    onChange={(e) =>
                                      handleFileUpload(e, "businessResolution")
                                    }
                                    id="BusinessResolution"
                                    className="input-file-type"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpg, image/jpeg"
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="col-xl-6">
                              <div className="col-lg-12 ml-n3">
                                <label
                                  htmlFor="firstname"
                                  className="label_text2 text-nowrap font-weight-bold"
                                >
                                  <b>
                                    {" "}
                                    Upload reference form
                                    {/* <sup style={{color: "red"}}>
                                    <b>**</b>
                                  </sup> */}
                                  </b>
                                </label>
                                <label
                                  className="cursor-pointer"
                                  htmlFor="referenceFormRealUpload"
                                >
                                  <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                    {showReferenceFormUpload ? (
                                      <p className="label_text">
                                        Reference Form Uploaded
                                      </p>
                                    ) : (
                                      <p className="label_text">
                                        Click to upload or drag
                                        <br />
                                        and drop file
                                      </p>
                                    )}

                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </div>
                                  <input
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        "referenceFormRealUpload",
                                      )
                                    }
                                    id="referenceFormRealUpload"
                                    className="input-file-type"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpg, image/jpeg"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mt-2">
                              <div className="col-md-6">
                                <label
                                  htmlFor="firstname"
                                  className="label_text2 text-nowrap font-weight-bold"
                                >
                                  <b>
                                    Others
                                    <sup style={{ color: "red" }}>
                                      <b>**</b>
                                    </sup>
                                  </b>
                                </label>
                                <label className="cursor-pointer">
                                  <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                    {showOthersDocument ? (
                                      <p className="label_text">
                                        Document uploaded
                                      </p>
                                    ) : (
                                      <p className="label_text">
                                        Click to upload or drag
                                        <br />
                                        and drop file
                                      </p>
                                    )}

                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </div>
                                  <input
                                    onChange={(e) =>
                                      handleFileUpload(e, "othersDocument")
                                    }
                                    className="input-file-type"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpg, image/jpeg"
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="col-xl-6">
                              <div className="col-lg-12 ml-n3">
                                <label
                                  htmlFor="firstname"
                                  className="label_text2 text-nowrap font-weight-bold"
                                >
                                  <b>
                                    {" "}
                                    Download Reference form
                                    {/* <sup style={{color: "red"}}>
                                    <b>**</b>
                                  </sup> */}
                                  </b>
                                </label>
                                <label
                                  className="cursor-pointer"
                                  htmlFor="BusinessName"
                                >
                                  <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                    <a
                                      href={referenceFormPdf}
                                      download="Reference Form"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <p className="label_text">
                                        Click to Download Reference form
                                      </p>
                                    </a>
                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </div>
                                  <input
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        "applicationForBusinessName",
                                      )
                                    }
                                    id="BusinessName"
                                    className="input-file-type"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpg, image/jpeg"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6 mt-2">
                              <div className="col-md-6">
                                <label
                                  htmlFor="firstname"
                                  className="label_text2 text-nowrap font-weight-bold"
                                >
                                  <b>
                                    {" "}
                                    Utility Bill
                                    <sup>
                                      <b>**</b>
                                    </sup>
                                  </b>
                                </label>
                                <label
                                  className="cursor-pointer"
                                  htmlFor="parentofUtilitybill"
                                >
                                  <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                                    {showUtilityBill ? (
                                      <p className="label_text">
                                        Utility Bill Uploaded
                                      </p>
                                    ) : (
                                      <p className="label_text">
                                        Click or drag <br /> and drop file
                                      </p>
                                    )}

                                    <img
                                      className="img-fluid"
                                      src={uploadArrow}
                                      alt=""
                                    />
                                  </div>

                                  <input
                                    onChange={(e) =>
                                      handleFileUpload(e, "utilityBill")
                                    }
                                    id="parentofUtilitybill"
                                    className="input-file-type"
                                    type="file"
                                    name="file"
                                    accept="image/png, image/jpg, image/jpeg"
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <br />
                      <div>
                        <label
                          htmlFor="branch domicilation"
                          className="label_text"
                        >
                          Select type of sector/industry
                        </label>
                        <select
                          name="typeOfIndustry"
                          value={selectIndustry}
                          onChange={handleChangeSelect}
                          className="form-control border-dark  bg-white py-2"
                          id=""
                        >
                          <option value="">
                            Select type of sector/industry
                          </option>
                          {industries.map((industry: IIndustry) => {
                            return (
                              <option key={industry.id} value={industry.id}>
                                {industry.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div>
                        <label
                          className="label_text"
                          style={{ margin: "20px 0 " }}
                        >
                          Select value-added services
                        </label>
                        <br />
                        <label
                          htmlFor="branch domicilation"
                          className="label_text"
                        >
                          Branch of account domiciliation
                        </label>
                        <select
                          name="branchOfDomiciliation"
                          value={branchOfDomiciliation}
                          onChange={handleChangeBranch}
                          className="form-control border-dark  bg-white py-2"
                          id=""
                        >
                          <option value="">
                            Select branch of account domiciliation
                          </option>
                          {bankBranches.map((branch: IBankBranch) => {
                            return (
                              <option
                                key={branch.brancH_CODE}
                                value={branch.brancH_CODE}
                              >
                                {branch.branch}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div>
                        <br />
                        <div
                          className="col-md-4 form-group"
                          style={{ display: "flex", width: "80%" }}
                        >
                          <div
                            className={`custom-control custom-checkbox input-group mb-2 ${styles.custom}`}
                          >
                            <input
                              name="smsAlertValueAddedService"
                              checked={smsAlert}
                              onChange={(e) => setSmsAlert(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox1"
                            />
                            <label
                              className="custom-control-label pl-3"
                              htmlFor="checkbox1"
                            >
                              SMS/ Email alert
                            </label>
                          </div>
                          <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                            {/* <input type="checkbox" className="custom-control-input" id="checkbox" onclick="ShowHideDiv(this)"> */}
                            <input
                              name="debitCardValueAddedService"
                              checked={chequeBook}
                              onChange={(e) => setChequeBook(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox"
                            />
                            <label
                              className="custom-control-label pl-3 text-nowrap"
                              htmlFor="checkbox"
                            >
                              Cheque book
                            </label>
                          </div>
                        </div>
                      </div>
                      <br />
                      <label
                        className="label_text"
                        style={{ margin: "0 0 10px 0" }}
                      >
                        Currencies of account to be opened
                      </label>
                      <div
                        // className="row container"
                        style={{ display: "flex", width: "80%" }}
                      >
                        <div className="col-md-4 form-group">
                          <div className="">
                            <input
                              name="smsAlertValueAddedService"
                              checked={ngn}
                              onChange={(e) => setNgn(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox1"
                            />
                            <label className="" htmlFor="checkbox1">
                              NGN
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4 form-group">
                          <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                            <input
                              name="emailAlertValueAddedService"
                              checked={usd}
                              onChange={(e) => setUsd(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox3"
                            />
                            <label
                              className="custom-control-label pl-3"
                              htmlFor="checkbox3"
                            >
                              USD
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4 form-group">
                          <div className="custom-control custom-checkbox checkbox-lg border-dark input-group mb-2">
                            <input
                              name="emailAlertValueAddedService"
                              checked={euro}
                              onChange={(e) => setEuro(e.target.checked)}
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox3"
                            />
                            <label
                              className="custom-control-label pl-3"
                              htmlFor="checkbox3"
                            >
                              EURO
                            </label>
                          </div>
                        </div>
                        <div className="col-md-4 form-group">
                          <div className="custom-control custom-checkbox checkbox-lg input-group mb-2">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="checkbox4"
                              checked={gdp}
                              onChange={(e) => setGdp(e.target.checked)}
                            />
                            <label
                              className="custom-control-label pl-3 text-nowrap"
                              htmlFor="checkbox4"
                            >
                              GDP
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row container mt-3 ">
                        <div
                          className={`custom-control custom-checkbox input-group mb-2 ${styles.custom}`}
                        >
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="checkbox4"
                            checked={termsAndCondition}
                            onChange={(e) =>
                              setTermsAndCondition(e.target.checked)
                            }
                          />
                          <label
                            className="custom-control-label pl-3"
                            htmlFor="checkbox4"
                          >
                            By checking this box, you have accepted the{" "}
                            <span>
                              <a
                                href={termsAndConditionPdf}
                                download="tac"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <u>Terms and conditions</u>
                              </a>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-2">
                      <div
                        className="mb-3 mr-4"
                        style={{ marginRight: "20px" }}
                      >
                        <button
                          className="btn btn-outline-gold mr-3 btn-filled-white"
                          onClick={movePrevious}
                        >
                          Previous
                        </button>
                      </div>
                      {!termsAndCondition || !smsAlert ? (
                        <button className={styles.submit}>Proceed</button>
                      ) : (
                        <>
                          {updating ? (
                            <div
                              className="spinner-border text-gold"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-danger btn-filled-red"
                              onClick={submitNewDocumentUpload}
                            >
                              Proceed
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {accountOpeningStep === "success-business-account" && (
                <div>
                  <div className="card-body text-center">
                    <SuccessIcon />
                    <h4 className="card-title text-center pl-3 mt-5">
                      Congratulations {businessName}, your <br /> account
                      opening was successful
                    </h4>
                    <p className="text-center text-muted">
                      Here is your account number
                    </p>
                    {fullAccountNumber.map((acc: any) => {
                      return (
                        <>
                          {acc?.accountNo?.length > 1 && (
                            <div className={styles.sucessFlexHolder}>
                              <div className={styles.successCurrency}>
                                {acc.currency}
                              </div>
                              <p className={styles.successAccountNumber}>
                                {acc.accountNo}
                              </p>
                              <img
                                className="img-fluid pb-2"
                                src={copyButton}
                                alt=""
                                onClick={() =>
                                  copyAccountNumberToClipboard(acc.accountNo)
                                }
                              />
                            </div>
                          )}
                        </>
                      );
                    })}
                  </div>

                  {/* <div className=" row text-center">
                    <div className="col-md-12">
                     
                    </div>
                  </div> */}
                  <div className={styles.flexFamily}>
                    <button
                      className="btn btn-outline-gold mr-3 btn-filled-white"
                      onClick={navigateHome}
                    >
                      Okay
                    </button>
                    {/* <button
                      type="submit"
                      className="btn btn-danger btn-filled-red"
                      onClick={addreference}
                    >
                      Add Reference
                    </button> */}
                  </div>
                </div>
              )}
              {accountOpeningStep === "add-reference" && (
                <NewAddReference universalID={universalID} />
              )}
            </div>
          </div>
        </div>
      </div>
      {signatory && (
        <div>
          <div className={styles.signatoryBg}>
            <div className={styles.signatoryContainer}>
              <div>
                <div className={styles.signHeader}>
                  <div className={styles.signFirst}>
                    <img
                      src={backArrow}
                      alt=""
                      onClick={() => setSignatory(false)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className={styles.signSecond}>
                    <h4>Add Signatory</h4>
                    <nav className="mb-4">
                      <ol className="breadcrumb bg-white float-right">
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            {/* {validated ? (
                              <span>
                                <img className="pr-1" src={Done} alt="" />
                              </span>
                            ) : (
                              <span>
                                <img className="pr-1" src={group1} alt="" />
                              </span>
                            )} */}
                            {/* Bvn Validation &nbsp;
                            <span>
                              <img src={rightArrow} alt="" />
                            </span> */}
                          </a>
                        </li>
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            {bvnUpdateValidated ? (
                              <span>
                                <img className="pr-1" src={Done} alt="" />
                              </span>
                            ) : (
                              <span>
                                <img className="pr-1" src={group1} alt="" />
                              </span>
                            )}
                            Update details &nbsp;
                            <span>
                              <img src={rightArrow} alt="" />
                            </span>
                          </a>
                        </li>
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            <span>
                              <img className="pr-1" src={no2} alt="" />
                            </span>{" "}
                            Mandates and documents
                          </a>
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                {bvnClose && (
                  <div className="card-form px-4">
                    {/* <Toaster position="top-center" reverseOrder={false} /> */}
                    <div className="card-body">
                      <div className="form-group">
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Enter BVN
                          </label>
                          <i
                            className="bx bxs-info-circle"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
                          ></i>
                        </div>
                        <input
                          name="bvn"
                          value={inputs.bvn}
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={11}
                          className="form-control bvn_input border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="Enter your BVN"
                        />
                      </div>

                      <div className="mt-4">
                        <label htmlFor="gender" className="fila">
                          Date of birth
                        </label>
                        <div className="form-group d-flex">
                          <select
                            name="day"
                            value={inputs.day}
                            onChange={handleChange}
                            className="form-control bvn_inpu border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Day</option>
                            {days.map((day) => {
                              return (
                                <option key={day} value={day}>
                                  {day}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="month"
                            value={inputs.month}
                            onChange={handleChange}
                            className="form-control bvn_input border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Month</option>
                            {months.map((month) => {
                              return (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="year"
                            value={inputs.year}
                            onChange={handleChange}
                            className="form-control bvn_input border-dark"
                          >
                            <option>Year</option>
                            {years.map((year) => {
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        {bvnValidating ? (
                          <div
                            className="spinner-border text-gold"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <button
                            className="btn btn-dange float-right btn-filled-red"
                            onClick={handleValidateBVN}
                          >
                            Validate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {bvnNextUpdated && (
                  <div>
                    <div className="bvn_val mb-4" id="fader">
                      <img src={Icon_L} alt="" />
                      <small className="text-danger ml-4 font-weight-bold">
                        <b>Update your address and email if it has changed</b>
                      </small>
                    </div>
                    <div>
                      <div className=" card-form pl- pr-">
                        <div className={styles.formflex}>
                          <div className={styles.form}>
                            <label className="label_text">
                              Firstname<sup style={{ color: "red" }}>*</sup>
                            </label>
                            <input
                              name="firstName"
                              value={signFirstName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">
                              Secondname<sup style={{ color: "red" }}>*</sup>
                            </label>
                            <input
                              name="secondName"
                              value={signMiddleName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">
                              Lastname<sup style={{ color: "red" }}>*</sup>
                            </label>
                            <input
                              name="lastName"
                              value={signLastName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    Phone number
                                    <sup style={{ color: "red" }}>*</sup>
                                  </label>
                                  <input
                                    name="phoneNumber"
                                    onChange={(e) => {
                                      setSignPhoneNumber(e.target.value);
                                    }}
                                    value={signPhoneNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter Phone number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Date of birth{" "}
                                    <sup style={{ color: "red" }}>*</sup>
                                  </label>
                                  <input
                                    value={`${inputs.month}-${inputs.day}-${inputs.year}`}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Email address{" "}
                              <sup style={{ color: "red" }}>*</sup>
                            </label>
                            <input
                              name="emailAddress"
                              onChange={(e) => {
                                setSignEmailAddress(e.target.value);
                              }}
                              value={signEmailAddress}
                              onBlur={handleOnBlurSignEmailAddress}
                              type="email"
                              className="form-control bg-white border-dark"
                              placeholder="Enter email address"
                            />
                            {signEmailAddressBlurred && (
                              <p className={styles.emailError}>
                                {EmailValidator.validate(signEmailAddress)
                                  ? ``
                                  : `Email is invalid`}
                              </p>
                            )}
                          </div>

                          <div className="row"></div>
                          <label
                            htmlFor="residentialaddress"
                            className="label_text my-2 font-weight-bold"
                          >
                            <b>
                              Residential<sup style={{ color: "red" }}>*</sup>
                            </b>
                          </label>

                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    House number{" "}
                                    <sup style={{ color: "red" }}>*</sup>
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignHouseNumber(e.target.value)
                                    }
                                    value={signHouseNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter house number"
                                    onKeyPress={handleKeyPress}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Street name{" "}
                                    <sup style={{ color: "red" }}>*</sup>
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignStreetName(e.target.value)
                                    }
                                    value={signStreetName}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter street name"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Area/State <sup style={{ color: "red" }}>*</sup>
                            </label>
                            {/* <input
                              onChange={(e) => setSignAreaState(e.target.value)}
                              value={signAreaState}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter Area/State"
                            /> */}

                            <select
                              onChange={(e) => setSignAreaState(e.target.value)}
                              value={signAreaState}
                              className="form-control border-dark"
                              style={{
                                padding: "13px",
                              }}
                            >
                              <option value="">Select state</option>
                              {statesInNigeria.map((state: any) => {
                                return (
                                  <option key={state.name} value={state.name}>
                                    {state.name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Nearest bus-top/landmark{" "}
                              <sup style={{ color: "red" }}>*</sup>
                            </label>
                            <input
                              onChange={(e) => setSignBusStop(e.target.value)}
                              value={signBusStop}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter nearest landmark"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Address <sup style={{ color: "red" }}>*</sup>
                            </label>
                            <input
                              value={`${signHouseNumber}, ${signStreetName} ${signBusStop} ${signAreaState}`}
                              className="form-control sec border-dark"
                              type="text"
                              placeholder="Enter full address"
                            />
                          </div>

                          <div className="row mt-3 mb-4">
                            <div className="col form-group">
                              <label htmlFor="religion" className="label_text">
                                Religion <sup style={{ color: "red" }}>*</sup>
                              </label>
                              <select
                                onChange={(e) =>
                                  setSignReligion(e.target.value)
                                }
                                value={signReligion}
                                className="form-control border-dark"
                              >
                                {getReligion.map((religion: IReligion) => {
                                  return (
                                    <option
                                      key={religion.id}
                                      value={religion.id}
                                    >
                                      {religion.religion}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>

                          <div className=" row form-group d-flex mb-4">
                            <div className="row">
                              <div className="col sec">
                                <div className="row form-row mb-3">
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="employment"
                                      className="label_text"
                                    >
                                      Select Nationality{" "}
                                      <sup style={{ color: "red" }}>*</sup>
                                    </label>
                                    <select
                                      name="selfEmploymentInformation"
                                      onChange={(e) =>
                                        setSignNationality(e.target.value)
                                      }
                                      value={signNationality}
                                      className="form-control border-dark bg-white"
                                      // placeholder="select Nationality"
                                    >
                                      <option value="" disabled hidden>
                                        select Nationality
                                      </option>
                                      {nationalityData.map((data) => {
                                        return (
                                          <option key={data.id} value={data.id}>
                                            {data.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="cerpacidNumber"
                                      className="label_text"
                                      style={{ fontSize: "0.6rem" }}
                                    >
                                      CERPAC ID number (If nationality is
                                      notNigerian)
                                    </label>
                                    <input
                                      name="cerpacidNumber"
                                      onChange={(e) =>
                                        setSignCerpacidNumber(e.target.value)
                                      }
                                      value={signCerpacidNumber}
                                      type="text"
                                      className="form-control bg-white border-dark"
                                      placeholder="eg 1234567890123"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            {/* <label className="label_text">
                              Select identity card type <sup style={{color: "red"}}>*</sup>
                            </label>

                            <ul
                              className="nav nav-pills identity-tab mb-3 nav-fill"
                              id="pills-tab"
                              role="tablist"
                            >
                              {meansOfIdentification.map(
                                (identification: IMeansOfIdentification) => {
                                  return (
                                    <li
                                      className="nav-item"
                                      key={identification.id}
                                      onClick={() =>
                                        handleSetIdCardType(identification.text)
                                      }
                                    >
                                      <a
                                        className={`nav-link text-nowrap pl-0 pt-2 ${identification.id == 1 ? "active" : ""
                                          }`}
                                        id="pills-int-tab"
                                        data-toggle="pill"
                                        href="#pills-int"
                                        role="tab"
                                        aria-controls="pills-int"
                                        aria-selected="true"
                                      >
                                        {identification.text}
                                      </a>
                                    </li>
                                  );
                                }
                              )}
                            </ul> */}
                            <div className="tab-content" id="pills-tabContent">
                              <div
                                className="tab-pane show fade active"
                                id="1"
                                role="tabpanel"
                                aria-labelledby="pills-int-tab"
                              >
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="label_text">
                                        ID card number{" "}
                                        <sup style={{ color: "red" }}>*</sup>
                                      </label>
                                      <input
                                        name="idCardNumber"
                                        onChange={(e) =>
                                          setSignIdCardNumber(e.target.value)
                                        }
                                        value={signIdCardNumber}
                                        className="form-control border-dark"
                                        type="text"
                                        placeholder="Enter ID card number"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group identity">
                                      <label
                                        htmlFor="issuedate"
                                        className="label_text"
                                      >
                                        Issue Date
                                      </label>
                                      <DatePickerComponent
                                        value={signIssueDate}
                                        setDate={setSignIssueDate}
                                        issueYear
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="label_text">
                                        Expiry Date
                                      </label>
                                      <DatePickerComponent
                                        value={signExpiryDate}
                                        setDate={setSignExpiryDate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group mt-4 mb-4">
                            <label className="label_text">
                              ID Card name <sup style={{ color: "red" }}>*</sup>
                            </label>
                            <input
                              className="form-control border-dark"
                              type="text"
                              value={signIdCardName}
                              onChange={(e) =>
                                setSignIdCardName(e.target.value)
                              }
                              placeholder="Enter ID Card Name"
                            />
                          </div>

                          <div className="d-flex justify-content-end mt-4">
                            <button
                              style={{ marginRight: "10px" }}
                              className="btn btn-outline-gold mr-3 btn-filled-white"
                              onClick={previousSigantoryBusinessDetails}
                            >
                              Previous
                            </button>
                            {businessSignatoryDetailsLoading ? (
                              <div
                                className="spinner-border text-gold"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-danger btn-filled-red"
                                onClick={businessSignatoryDetails}
                              >
                                Proceed
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {bvnNextMandate && (
                  <div>
                    <div className={styles.signDoubleHeader}>
                      <label htmlFor="">Mandate instruction</label>
                      <br />
                      <textarea
                        placeholder="Enter mandate instruction"
                        value={mandate}
                        onChange={(e) => setMandate(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Signature
                          </label>
                          <label
                            className="cursor-pointer"
                            htmlFor="parentofCertificateOfResgistration"
                          >
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}

                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "signature")}
                              id="parentofCertificateOfResgistration"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="col-lg-12 ml-n3">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload passport
                          </label>
                          <label className="cursor-pointer">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showBusinessSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) =>
                                handleFileUpload(e, "BusinessName")
                              }
                              id="BusinessName"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Scanned ID
                          </label>
                          <label className="cursor-pointer" htmlFor="parentof">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadScannedID ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "scannedID")}
                              id="parentof"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        style={{ marginRight: "10px" }}
                        className="btn btn-outline-gold mr-3 btn-filled-white"
                        onClick={previousMandateFuntion}
                      >
                        Previous
                      </button>
                      {mandate?.length < 1 ||
                      !showBusinessSignature ||
                      !showUploadScannedID ||
                      !showUploadSignature ? (
                        <button className={styles.submit}>Add signatory</button>
                      ) : (
                        <>
                          {updating ? (
                            <div
                              className="spinner-border text-gold"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-danger btn-filled-red"
                              onClick={addedSignatory}
                            >
                              Add signatory
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {extraSignatory && (
        <div>
          <div className={styles.signatoryBg}>
            <div className={styles.signatoryContainer}>
              <div>
                <div className={styles.signHeader}>
                  <div className={styles.signFirst}>
                    <img
                      src={backArrow}
                      alt=""
                      onClick={() => setExtraSignatory(false)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className={styles.signSecond}>
                    <h4>Add Signatory</h4>
                    <nav className="mb-4">
                      <ol className="breadcrumb bg-white float-right">
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            {/* {validated ? (
                              <span>
                                <img className="pr-1" src={Done} alt="" />
                              </span>
                            ) : (
                              <span>
                                <img className="pr-1" src={group1} alt="" />
                              </span>
                            )} */}
                            {/* Bvn Validation &nbsp;
                            <span>
                              <img src={rightArrow} alt="" />
                            </span> */}
                          </a>
                        </li>
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            {bvnUpdateValidated ? (
                              <span>
                                <img className="pr-1" src={Done} alt="" />
                              </span>
                            ) : (
                              <span>
                                <img className="pr-1" src={group1} alt="" />
                              </span>
                            )}
                            Update details &nbsp;
                            <span>
                              <img src={rightArrow} alt="" />
                            </span>
                          </a>
                        </li>
                        <li className="breadcrumb-item">
                          {" "}
                          <a href="#">
                            <span>
                              <img className="pr-1" src={no2} alt="" />
                            </span>{" "}
                            Mandates and documents
                          </a>
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
                {bvnClose && (
                  <div className="card-form px-4">
                    {/* <Toaster position="top-center" reverseOrder={false} /> */}
                    <div className="card-body">
                      <div className="form-group">
                        <div className="d-flex justify-content-between pb-1 fillup">
                          <label htmlFor="name" className="fila">
                            Enter BVN
                          </label>
                          <i
                            className="bx bxs-info-circle"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="The Bank Verification Number (BVN) is an 11-digit number.Dial *565*0# to check your BVN"
                          ></i>
                        </div>
                        <input
                          name="bvn"
                          value={extraInputs.bvn}
                          onChange={handleExtraChange}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          maxLength={11}
                          className="form-control bvn_input border-dark"
                          style={{ textAlign: "left" }}
                          type="text"
                          id="bvn"
                          placeholder="Enter your BVN"
                        />
                      </div>

                      <div className="mt-4">
                        <label htmlFor="gender" className="fila">
                          Date of birth
                        </label>
                        <div className="form-group d-flex">
                          <select
                            name="day"
                            value={extraInputs.day}
                            onChange={handleExtraChange}
                            className="form-control bvn_inpu border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Day</option>
                            {days.map((day) => {
                              return (
                                <option key={day} value={day}>
                                  {day}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="month"
                            value={extraInputs.month}
                            onChange={handleExtraChange}
                            className="form-control bvn_input border-dark"
                            style={{ marginRight: "10px" }}
                          >
                            <option>Month</option>
                            {months.map((month) => {
                              return (
                                <option key={month} value={month}>
                                  {month}
                                </option>
                              );
                            })}
                          </select>
                          <select
                            name="year"
                            value={extraInputs.year}
                            onChange={handleExtraChange}
                            className="form-control bvn_input border-dark"
                          >
                            <option>Year</option>
                            {years.map((year) => {
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="d-flex justify-content-end mt-4">
                        {bvnValidating ? (
                          <div
                            className="spinner-border text-gold"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <button
                            className="btn btn-dange float-right btn-filled-red"
                            onClick={validateExtraBVN}
                          >
                            Validate
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {bvnNextUpdated && (
                  <div>
                    <div className="bvn_val mb-4" id="fader">
                      <img src={Icon_L} alt="" />
                      <small className="text-danger ml-4 font-weight-bold">
                        <b>Update your address and email if it has changed</b>
                      </small>
                    </div>
                    <div>
                      <div className=" card-form pl- pr-">
                        <div className={styles.formflex}>
                          <div className={styles.form}>
                            <label className="label_text">Firstname</label>
                            <input
                              value={signExtraFirstName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">Secondname</label>
                            <input
                              value={signExtraMiddleName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                          <div className={styles.form}>
                            <label className="label_text">Lastname</label>
                            <input
                              name="lastName"
                              value={signExtraLastName}
                              type="text"
                              className="form-control bg-white border-dark"
                              disabled
                            />
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    Phone number
                                  </label>
                                  <input
                                    name="phoneNumber"
                                    value={signExtraPhoneNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter Phone number"
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Date of birth
                                  </label>
                                  <input
                                    value={`${extraInputs.month}-${extraInputs.day}-${extraInputs.year}`}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">Email address*</label>
                            <input
                              name="emailAddress"
                              onChange={(e) => {
                                setSignEmailAddress(e.target.value);
                              }}
                              value={signEmailAddress}
                              onBlur={handleOnBlurEmailAddress}
                              type="email"
                              className="form-control bg-white border-dark"
                              placeholder="eg johndoe@gmail.com"
                            />
                            {emailAddressBlurred && (
                              <p className={styles.emailError}>
                                {EmailValidator.validate(signEmailAddress)
                                  ? ``
                                  : `Email is invalid`}
                              </p>
                            )}
                          </div>

                          <div className="row"></div>
                          <label
                            htmlFor="residentialaddress"
                            className="label_text my-2 font-weight-bold"
                          >
                            <b>Residential address</b>
                          </label>

                          <div className="row">
                            <div className="col sec">
                              <div className="row form-row mb-3">
                                <div className="col-lg-6 mr-2">
                                  <label className="label_text">
                                    House number
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignHouseNumber(e.target.value)
                                    }
                                    value={signHouseNumber}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter house number"
                                    onKeyPress={handleKeyPress}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <label className="label_text">
                                    Street name
                                  </label>
                                  <input
                                    onChange={(e) =>
                                      setSignStreetName(e.target.value)
                                    }
                                    value={signStreetName}
                                    type="text"
                                    className="form-control bg-white border-dark"
                                    placeholder="Enter street name"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">Area/State</label>
                            {/* <input
                              onChange={(e) => setSignAreaState(e.target.value)}
                              value={signAreaState}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter Area/State"
                            /> */}
                            <select
                              onChange={(e) => setSignAreaState(e.target.value)}
                              value={signAreaState}
                              className="form-control border-dark"
                              style={{
                                padding: "13px",
                              }}
                            >
                              <option value="">Select state</option>
                              {statesInNigeria.map((state: any) => {
                                return (
                                  <option key={state.name} value={state.name}>
                                    {state.name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Nearest bus-top/landmark
                            </label>
                            <input
                              onChange={(e) => setSignBusStop(e.target.value)}
                              value={signBusStop}
                              type="text"
                              className="form-control bg-white border-dark"
                              placeholder="Enter nearest landmark"
                            />
                          </div>

                          <div className="form-group">
                            <label className="label_text">Address</label>
                            <input
                              value={`${signHouseNumber}, ${signStreetName} ${signBusStop} ${signAreaState}`}
                              className="form-control sec border-dark"
                              type="text"
                              placeholder="Enter full address"
                            />
                          </div>

                          <div className="row mt-3 mb-4">
                            <div className="col form-group">
                              <label htmlFor="religion" className="label_text">
                                Religion
                              </label>
                              <select
                                onChange={(e) =>
                                  setSignReligion(e.target.value)
                                }
                                value={signReligion}
                                className="form-control border-dark"
                              >
                                {getReligion.map((religion: IReligion) => {
                                  return (
                                    <option
                                      key={religion.id}
                                      value={religion.id}
                                    >
                                      {religion.religion}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>

                          <div className=" row form-group d-flex mb-4">
                            <div className="row">
                              <div className="col sec">
                                <div className="row form-row mb-3">
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="employment"
                                      className="label_text"
                                    >
                                      Select Nationality
                                    </label>
                                    <select
                                      name="selfEmploymentInformation"
                                      onChange={(e) =>
                                        setSignNationality(e.target.value)
                                      }
                                      value={signNationality}
                                      className="form-control border-dark bg-white"
                                      // placeholder="select Nationality"
                                    >
                                      <option value="" disabled hidden>
                                        select Nationality
                                      </option>
                                      {nationalityData.map((data) => {
                                        return (
                                          <option key={data.id} value={data.id}>
                                            {data.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                  <div className="col-lg-6">
                                    <label
                                      htmlFor="cerpacidNumber"
                                      className="label_text"
                                      style={{ fontSize: "0.6rem" }}
                                    >
                                      CERPAC ID number (If nationality is
                                      notNigerian)
                                    </label>
                                    <input
                                      name="cerpacidNumber"
                                      onChange={(e) =>
                                        setSignCerpacidNumber(e.target.value)
                                      }
                                      value={signCerpacidNumber}
                                      type="text"
                                      className="form-control bg-white border-dark"
                                      placeholder="eg 1234567890123"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group">
                            <label className="label_text">
                              Select identity card type
                            </label>

                            {/* <ul
                              className="nav nav-pills identity-tab mb-3 nav-fill"
                              id="pills-tab"
                              role="tablist"
                            >
                              {meansOfIdentification.map(
                                (identification: IMeansOfIdentification) => {
                                  return (
                                    <li
                                      className="nav-item"
                                      key={identification.id}
                                      onClick={() =>
                                        handleSetIdCardType(identification.text)
                                      }
                                    >
                                      <a
                                        className={`nav-link text-nowrap pl-0 pt-2 ${identification.id == 1 ? "active" : ""
                                          }`}
                                        id="pills-int-tab"
                                        data-toggle="pill"
                                        href="#pills-int"
                                        role="tab"
                                        aria-controls="pills-int"
                                        aria-selected="true"
                                      >
                                        {identification.text}
                                      </a>
                                    </li>
                                  );
                                }
                              )}
                            </ul> */}
                            <div className="tab-content" id="pills-tabContent">
                              <div
                                className="tab-pane show fade active"
                                id="1"
                                role="tabpanel"
                                aria-labelledby="pills-int-tab"
                              >
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="label_text">
                                        ID card number
                                      </label>
                                      <input
                                        name="idCardNumber"
                                        onChange={(e) =>
                                          setSignIdCardNumber(e.target.value)
                                        }
                                        value={signIdCardNumber}
                                        className="form-control border-dark"
                                        type="text"
                                        placeholder="Enter ID card number"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group identity">
                                      <label
                                        htmlFor="issuedate"
                                        className="label_text"
                                      >
                                        Issue Date
                                      </label>
                                      <DatePickerComponent
                                        value={signIssueDate}
                                        setDate={setSignIssueDate}
                                        issueYear
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label className="label_text">
                                        Expiry Date
                                      </label>
                                      <DatePickerComponent
                                        value={signExpiryDate}
                                        setDate={setSignExpiryDate}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-group mt-4 mb-4">
                            <label className="label_text">ID Card name</label>
                            <input
                              className="form-control border-dark"
                              type="text"
                              value={signIdCardName}
                              onChange={(e) =>
                                setSignIdCardName(e.target.value)
                              }
                              placeholder="Enter ID Card Name"
                            />
                          </div>

                          <div className="d-flex justify-content-end mt-4">
                            <button
                              style={{ marginRight: "10px" }}
                              className="btn btn-outline-gold mr-3 btn-filled-white"
                              onClick={previousSigantoryBusinessDetails}
                            >
                              Previous
                            </button>
                            {businessSignatoryDetailsLoading ? (
                              <div
                                className="spinner-border text-gold"
                                role="status"
                              >
                                <span className="sr-only"></span>
                              </div>
                            ) : (
                              <button
                                type="submit"
                                className="btn btn-danger btn-filled-red"
                                onClick={businessSignatoryExtraDetails}
                              >
                                Proceed
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {bvnNextMandate && (
                  <div>
                    <div className={styles.signDoubleHeader}>
                      <label htmlFor="">Mandate instruction</label>
                      <br />
                      <textarea
                        placeholder="Enter mandate instruction"
                        value={mandate}
                        onChange={(e) => setMandate(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Signature
                          </label>
                          <label
                            className="cursor-pointer"
                            htmlFor="parentofCertificateOfResgistration"
                          >
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}

                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "signature")}
                              id="parentofCertificateOfResgistration"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="col-lg-12 ml-n3">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload passport
                          </label>
                          <label className="cursor-pointer">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showBusinessSignature ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) =>
                                handleFileUpload(e, "BusinessName")
                              }
                              id="BusinessName"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row" style={{ marginLeft: "4px" }}>
                      <div className="col-md-6 mt-2">
                        <div className="col-md-6">
                          <label
                            htmlFor="firstname"
                            className="label_text2 text-nowrap font-weight-bold"
                          >
                            Upload Scanned ID
                          </label>
                          <label className="cursor-pointer" htmlFor="parentof">
                            <div className="pic_upload2 d-flex justify-content-between pt-3 pr-3 px-2">
                              {showUploadScannedID ? (
                                <p className="label_text">File Uploaded</p>
                              ) : (
                                <p className="label_text">
                                  Click or drag <br /> and drop file
                                </p>
                              )}
                              <img
                                className="img-fluid"
                                src={uploadArrow}
                                alt=""
                              />
                            </div>
                            <input
                              onChange={(e) => handleFileUpload(e, "scannedID")}
                              id="parentof"
                              className="input-file-type"
                              type="file"
                              name="file"
                              accept="image/png, image/jpg, image/jpeg"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-4">
                      <button
                        style={{ marginRight: "10px" }}
                        className="btn btn-outline-gold mr-3 btn-filled-white"
                        onClick={previousMandateFuntion}
                      >
                        Previous
                      </button>
                      {mandate?.length < 1 ||
                      !showBusinessSignature ||
                      !showUploadScannedID ||
                      !showUploadSignature ? (
                        <button className={styles.submit}>Add signatory</button>
                      ) : (
                        <>
                          {updating ? (
                            <div
                              className="spinner-border text-gold"
                              role="status"
                            >
                              <span className="sr-only"></span>
                            </div>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-danger btn-filled-red"
                              onClick={addedExtraSignatory}
                            >
                              Add signatory
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BusinessOpenAccount;

//@ts-ignore
const ExampleCustomInput = React.forwardRef(({ value, onClick, ref }) => (
  <div>
    <input
      type="text"
      className="form-control border-dark bg-white"
      onClick={onClick}
      ref={ref}
      value={value}
    />
  </div>
));
